import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonDownloadLinkFromS3 } from 'src/app/shared/common/commonDownloadLinkFromS3';
import { FiledownloadComponent } from 'src/app/shared/common/filedownload.component';
import { AttributeMappingConfigService } from 'src/app/shared/services/attribute-mapping-config.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { EtlService } from '../vault-data-migration-etl/etl.service';
import { constants } from 'src/app/shared/common/contants';
import { equal } from 'assert';
import { VaultObjectRelationshipService } from 'src/app/shared/services/vault-object-relationship.service';
import { stagger } from '@angular/animations';
import { type } from 'os';
import { FieldMappingService } from 'src/app/shared/services/field-mapping.service';

import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { ExceljsServiceService } from 'src/app/shared/services/exceljs-service.service';

export interface uploadExcelFileComponent {
  edata: any;
  duplicates:boolean,
  message:any,
  attributes:any;
  dnsname:any,
  listOfSourceObjects:any,
  stageObjectslist:any,
  globalObjectsList:any,
  globalSourceObjectsList:any,
  externalObjectsList:any,
  libraryObjectsList:any,
  objectGroupData:any

}


@Component({
    selector: 'app-upload-excel-file',
    templateUrl: './upload-excel-file.component.html',
    styleUrls: ['./upload-excel-file.component.scss'],
    standalone: false
})
export class UploadExcelFileComponent implements OnInit {

  gridAPI;
   lastPage;
   currentPage;
   nextPage;
   nextPagePlusOne;
   totalPages;
   gridColumnAPI;
   columnDefs;
   rowData;
   rowClassRules;
   defaultColDef;
   rowSelection;
   paginationPageSize;
   paginationNumberFormatter;
   pageSize;
   components: any;
   overlayNoRowsTemplate;
 
   getdata: any = [];
   reportData: any;
   userid: any;
   fieldslist: any = {};
 
   backgroundColorButton = "";
   backgroundColorScreen: string;
   bucketName;
  duplicates: boolean;
  sourceObjectsList: any;
  sourceDetails: any;
  targetDetails: any;
  TargetObjectsList: any;
  mappedObjects: any[];
  sourceObjectsLoaded: boolean;
  targetObjectsLoaded: boolean;
  mappingDtoPayloads: any;
  mappingTypeDataDropDown:any=[]
  default:any = []
  mappingDto: {
    mappingconfigurationid: number; // assuming it's auto-generated or set later
    stageobject: any; stageobjectid: any; targetobject: any; targetobjectid: any; status: any; tenantid: string; // or any fallback
    sourcedns: any; sourcednsid: any; targetdns: any; targetdnsid: any;
  }[];
  sourceAttributesList: any;
  targetAttributesList: any;
  TEMPLATE_HEADERS: string[] = [];
    fileNameList: any[] = [];

  // readonly TEMPLATE_HEADERS: string[] = [
  //   "Source Object",
  //   "Target Object",
  //   "Source Attributes",
  //   "Target Attribute",
  //   "Mapping Type",
  //   "Codelist Name",
  //   "Transformation Expressions",
  //   "Exception Expressions",
  //   "Bussiness Logic"
  // ];
  readonly HEADER_TEMPLATES: { [key: string]: string[] } = {
    mappingattributes: [
      "Source Object",
      "Target Object",
      "Source Attributes",
      "Target Attribute",
      "Mapping Type",
      "Codelist Name",
      "Transformation Expressions",
      "Exception Expressions",
      "Bussiness Logic",
      "Codelist Value Type",
      "Selected Object",
      "Selected Attribute",
      "Query",
      "Reference Source Objects",
      "Reference Target Objects",
      "Reference Value Mapping",
      "Reference Library Objects",
      "Reference Global Objects",
      "Reference Global Source Objects",
      "Global External Objects",
      "Reference DB Object Name",
      "Reference DB Object Fetch Partials"
    ],
    objectmetadata: [
      "Object Name",
      "Object Label",
      "Object Type",
      "Attributes",
      "Parent Object",
      "Primary Key",
      "Referencing Key",
      "Referenced Key",
      "Trigger Allowed",
      "Is Parent(Yes or No)",
      "Status Col",
      "Source"
    ],
     vaultobjectrelationship:[
   "Id",
	"Object Name",
	"Parent Object Name",
	"Unique Key Column",
	"Columns From Parent File",
	"Parent Ref Column",
	"Parent File Name",
	"Child File Name",
	"Uniquekey Column D2D Validation",
	"Reference Column Mapping",
	"Primary Column"
],
loadobjectsmstr:[
	"Load Object Id",
	"Object Name",
	"Load Order",
	"Is Loadable",
	"Is Parent",
	"Object Level",
	"Deferred",
	"Vault Extraction",
	"Vql Criteria",
	"Global Object",
	"Parent Object Name For Extraction",
	"Type",
	"Object Type",
	"File Name",
	"Deletion Level",
	"Load Action",
	"Object Group Name",
	"Source Data Extraction VQL",
  "Migration Mode",
  "Self Reference Object",
  "Self Reference Fields",
  "Circular Reference Object",
  "Circular Reference Fields"
	
],
sqlscripts__j:[
	"Id",
	"SQL Query",
  "Pre_defined_sqlscript__j",
  "Format Date",
	"File Name",
	"Execution Order",
	"Attachment Query",
	"Extraction Type(CsvExtraction/AttachmentExtraction/AuditTrailExtraction/GlobalExtraction)",
	"Is Executable",
	"Query Execution Type",
	"Data Source Type",
	"Group Name",
  "Object Name",
	"Set Split Required",
	"Group Extraction Type(Full Data/Partial Data)",
	"Source Connection String"
	
],
stageobjects:[
  
"Object Group Name",
"Stage Object Label",
"Stage Object Name",
"Flattening option",
"Order Id",
"Object Name",
"Object Label",
"Attributes",
"Expression Query",
"Column Filters",
"Sorting",
"Reference Source Objects",
"Reference Transform Objects",
"Reference Value Mapping",
"Reference Library Objects",
"Reference Global Objects",
"Reference Global Source Objects",
"Global External Objects",
"Reference DB Object Name",
"Reference DB Object Fetch Partials"
]
    
    // Add more templates as needed
  };
  
  tableName: string;
  excelData: any;
  uploadData: { csvContent: any[]; fileName: string; duplicates: boolean; attributes: boolean; };
  isGridVisible: boolean;
  showbutton: boolean;
  referenceExternalObjectsList: any;
  referenceTargetObjectsList: any;
  codeListData: any;
  combinedObjectList: any[];
  uploadFile: boolean;
  templateFile: boolean;
  listOfObjectsOfSource: any;
  invalidStageRows: any[];
  flatteningOptionList :any[]=["None","Flatten Data","Flatten without duplicates"]
  finalStageJsons: {
    datasetname: any; description: any; objectGroup: number; filters: any[]; sorting: any[]; aggregate: any[]; columns: any[]; concatination: any[]; rollingUp: any[]; rollupExclusionObjects: any[]; transformation: any[]; columnFilters: any[]; columnFiltersExpression: string; generateDefaultTemplate: boolean; selectedObjectsMap: any; transformationQuery: any; flatteningOption: any; rows: {
      objectId: any; objectLabel: any; objects: any; attributes: any,reference_source:any,reference_target:any,reference_library:any,reference_global_object:any,reference_global_source_library:any,reference_vault_object:any,global_external_object:any, remarks: any,reference_Database_Object_Name:any,reference_Database_Object_Fetch_Partial:any;
    }[];
  }[];
  failedRecords: any[];
  invalidStageJsons: {
    datasetname: any; description: any; objectGroup: number; filters: any[]; sorting: any[]; aggregate: any[]; columns: any[]; concatination: any[]; rollingUp: any[]; rollupExclusionObjects: any[]; transformation: any[]; columnFilters: any[]; columnFiltersExpression: string; generateDefaultTemplate: boolean; selectedObjectsMap: any; transformationQuery: any; flatteningOption: any; rows: {
      objectId: any; objectLabel: any; objects: any; attributes: any,reference_source:any,reference_target:any,reference_library:any,reference_global_object:any,reference_global_source_library:any,reference_vault_object:any,global_external_object:any, remarks: any,reference_Database_Object_Name:any,reference_Database_Object_Fetch_Partial:any;
    }[];
  }[];
  validStageJsons: {
   datasetname: any; description: any; objectGroup: number; filters: any[]; sorting: any[]; aggregate: any[]; columns: any[]; concatination: any[]; rollingUp: any[]; rollupExclusionObjects: any[]; transformation: any[]; columnFilters: any[]; columnFiltersExpression: string; generateDefaultTemplate: boolean; selectedObjectsMap: any; transformationQuery: any; flatteningOption: any; rows: {
      objectId: any; objectLabel: any; objects: any; attributes: any,reference_source:any,reference_target:any,reference_library:any,reference_global_object:any,reference_global_source_library:any,reference_vault_object:any,global_external_object:any, remarks: any,reference_Database_Object_Name:any,reference_Database_Object_Fetch_Partial:any;
    }[];
  }[];
  invalidRowdataOfStage: {
    datasetname: any; description: any; columns: string; sorting: string; columnfilter: string; transformationQuery: any;
    // 🔹 collect all row-level remarks
    remarks: string;
  }[];
  uniquenessErrors: any[];
  fieldLabelMap: { [key: string]: string } = {
  datasetname: "Stage Object Label",
  description: "Stage Object Name",
  flatteningOption: "Flattening Option",
  orderId: "Order Id",
  objects: "Object Name",
  objectlabelname: "Object Label",
  attributes: "Attributes",
  transformationQuery: "Expression Query",
  columnfilter: "Column Filters",
  sorting: "Sorting",
  remarks: "Remarks"
};
   mappingConfigurationData:any=[]
  referenceLibraryObjectsLookupValue: any;
  referenceLibraryObjectsList: any;
  referenceGlobalObjectsLookupValue: any;
  referenceGlobalObjectsList: any;
  referenceSourceGlobalObjectsList: any;
  dataSourceName: any =[];
  queryExecutionType: any=[];
   constructor(private commonService: CommonService, private snackbar: MatSnackBar, private constants: constants, private loginService: LoginService, private localStorageSettings: LocalStorageSettingsService,private mappingAttributeServices:AttributeMappingConfigService,private spinner: NgxUiLoaderService,
   private etlService: EtlService,private dialogref: MatDialogRef<UploadExcelFileComponent>,@Inject(MAT_DIALOG_DATA) public data: uploadExcelFileComponent, private vaultObjectRelationshipService:VaultObjectRelationshipService, private valueMappingservice: FieldMappingService,private reportingService: ReportingServiceService, private excelService:ExceljsServiceService
   ) {
     //cell rendering in ag-grid
     this.components = {
       
     }
 
     //if no rows , this message will display
     this.overlayNoRowsTemplate = this.constants.Norows;
   }
 
   ngOnInit(): void {
    console.log(this.data.edata)
    const name =(this.data?.edata || '').toLowerCase();
    const dnsname = this.data.dnsname
    console.log(dnsname)
    this.uploadFile = true;
    this.templateFile = true;
    if (this.HEADER_TEMPLATES[name]) {
      this.TEMPLATE_HEADERS = this.HEADER_TEMPLATES[name];
    } else {
      console.warn('No matching header template found for:', name);
      this.TEMPLATE_HEADERS = []; // or a default fallback
    }
  
    console.log('Resolved TEMPLATE_HEADERS:', this.TEMPLATE_HEADERS);
     if (this.data.edata == 'mappingattributes') {
      this.commonService.getlookupVauleByLookUpType("Mapping Type").subscribe(result => {
      console.log(result);
      this.mappingTypeDataDropDown = result;
      console.log(this.mappingTypeDataDropDown)

    });
      this.commonService.getlookupVauleByLookUpType("codelistValueType").subscribe(result => {
      console.log(result);
      this.default = result;
      console.log(this.default)

    });
     let dnsId = this.localStorageSettings.getSettings("dnsName");
    this.valueMappingservice.retreiveMappingTypes(dnsId).subscribe(response=>{
      console.log(response)
      this.codeListData=response;
    })
    
 this.commonService.retrieveMappingConfiguration().subscribe(response => {
      // this.spinner.start();
      console.log(response);
      // checking if response is true or not
      if (response.error == true) {
        // this.snackbar.open(response.statusMessage, "OK", {
        //   duration: 5000,
        // });
        
        // this.spinner.stop();
      } else {
        console.log(response)
        this.mappingConfigurationData=response;
        if(this.mappingConfigurationData.length > 0){
        this.mappingConfigurationData=this.mappingConfigurationData.map(obj => ({
          ...obj,
          combined: `${obj.stageobject}_${obj.targetobject}`
        }));
        }
        // this.spinner.stop();
      }
      
    });
  
    this.retrieveSourceAndTargetInfo();

  }
  if(this.data.edata == 'stageobjects'){
    console.log(this.data.stageObjectslist)
    console.log(this.data.globalObjectsList)
    console.log(this.data.globalSourceObjectsList)
    console.log(this.data.externalObjectsList)
    console.log(this.data.libraryObjectsList)
    console.log(this.data.objectGroupData);
    
    // this.retrieveSourceAndTargetInfo();
    this.listOfObjectsOfSource=this.data.listOfSourceObjects
    console.log(this.listOfObjectsOfSource)
    let dnsId = this.localStorageSettings.getSettings("dnsName");
    this.valueMappingservice.retreiveMappingTypes(dnsId).subscribe(response=>{
      console.log(response)
      this.codeListData=response;
    })
    
    this.retrieveSourceAndTargetInfo();
  }

     this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
     this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
     
   }
 
  
   onPaginationChanged() {
     if (this.gridAPI) {
       this.lastPage = this.gridAPI.paginationIsLastPageFound();
       this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1
       this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1
       this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1
       this.totalPages = this.gridAPI.paginationGetTotalPages()
     }
   }
 
   //this function is for going to the given page number 
   onSearchChange(searchValue: number) {
     this.gridAPI.paginationGoToPage(searchValue - 1);
   }
 
   // below function is for changing the no of rows per page
   onPageSizeChanged() {
     var value = this.pageSize;
     this.gridAPI.setGridOption('paginationPageSize', Number(value));
   }
 
   // below function is for going to next page
   onBtNext() {
     console.log("next")
     this.gridAPI.paginationGoToNextPage();
   }
   onBtExport() {
     this.gridAPI.exportDataAsCsv();
   }
   // below function for going to previous page
   onBtPrevious() {
     console.log("previous")
     this.gridAPI.paginationGoToPreviousPage();
   }
 
   // below function for going to first page
   onBtFirst() {
     this.gridAPI.paginationGoToFirstPage();
   }
 
   // below function for going to last page
   onBtLast() {
     this.gridAPI.paginationGoToLastPage();
   }
 
   
 
    onGridReady(params) {
 
     this.spinner.start();
     this.gridAPI = params.api
     this.gridColumnAPI = params.columnApi;
     this.gridAPI.setGridOption('rowData', this.rowData);

     let dnsId = this.localStorageSettings.getSettings("dnsName");;
    //  this.spinner.stop();
    if(this.data.edata !== 'mappingattributes'){
      this.spinner.stop()
    }
  
   }
 
   
        /**
	 * @Author: Venkata Shyam
	 * @Date:18-06-2025
	 * @description: In this method all the validation of uploaded excel 
   * file will happen regarding the manditory fileds and if the all the manditory fileds are passeding sending data to save
	 */ 
 objectAttributesMap:any
 SourceObjectListName
 sourceObjectNameSet:any
   openSaveForm() {
    let manditoryFields
    console.log(this.data.edata);
    if(this.data.edata==='mappingattributes'){
       manditoryFields =['source_object','target_object','source_attribute','target_attribute','mapping_type']
    this. objectAttributesMap = new Map<string, string[]>();
    this. sourceObjectNameSet = new Set<string>();
    this.combinedObjectList = [...this.sourceObjectsList,...this.TargetObjectsList,...this.codeListData]
    console.log(this.combinedObjectList)
  for (const obj of this.combinedObjectList) {
    const objectName = obj.objectname?.toLowerCase().trim();
    // this.SourceObjectListName = objectName
    if (!objectName) continue;
    this.sourceObjectNameSet.add(objectName);
    let allowedAttrNames: string[] = [];

    // try {
    //   const parsedAttrs = JSON.parse(obj.objectattributes);

    //   if (Array.isArray(parsedAttrs)) {
    //     allowedAttrNames = parsedAttrs.map(attr => attr.name?.toLowerCase().trim()).filter(Boolean);
    //   } else if (typeof parsedAttrs === 'object' && parsedAttrs.datasets) {
    //     parsedAttrs.datasets.forEach((ds: any) => {
    //       if (Array.isArray(ds.columns)) {
    //         ds.columns.forEach((col: any) => {
    //           if (col.name) allowedAttrNames.push(col.name.toLowerCase().trim());
    //         });
    //       }
    //     });
    //   }
    // } catch (e) {
    //   console.warn(`Failed to parse objectattributes for object "${objectName}"`);
    // }

    // this.objectAttributesMap.set(objectName, allowedAttrNames);
  }

    }else if(this.data.edata === 'objectmetadata'){
      manditoryFields = ['objectlabel','objectname','attributes','primarykey','source','isParentorchild']
    }else if(this.data.edata === 'vaultobjectrelationship'){
      manditoryFields = ['objectname','parentobjectname','uniquekeycolumn','columnsfromparentfile','parentrefcolumn','parentfilename','childfilename']
    }else if(this.data.edata === 'loadobjectsmstr'){
      manditoryFields = ['objectname','loadorder','level','vaultextraction','objecttype','fileName']
    }else if(this.data.edata === 'sqlscripts__j'){
      manditoryFields = ['sqlscript__j','filename__j','executionorder__j','automatically_formate','attachmentquery__j','extractiontype__j','isExecutable__j','queryexecutiontype__j','sourceconnectionstring__j','sourcetype__j','objectgroupname','setssplitrequired','objectname','groupextractiontype']
    }else if(this.data.edata === 'stageobjects'){
      manditoryFields = ['datasetname','description','objects','objectlabelname','attributes','transformationQuery','orderId']
      this. objectAttributesMap = new Map<string, string[]>();
    this. sourceObjectNameSet = new Set<string>();
    console.log(this.sourceObjectsList);
    if(this.sourceObjectsList == undefined){
      this.sourceObjectsList=[]
    }
    this.combinedObjectList = [...this.sourceObjectsList,...this.TargetObjectsList,...this.codeListData]
    console.log(this.combinedObjectList)
    for (const obj of this.combinedObjectList) {
    const objectName = obj.objectname?.toLowerCase().trim();
    // this.SourceObjectListName = objectName
    if (!objectName) continue;
    this.sourceObjectNameSet.add(objectName);
    let allowedAttrNames: string[] = [];
    }
    }


     for(let i=0; i < this.rowData.length; i++){
      const row = this.rowData[i];
      if(this.data.edata === 'stageobjects'){
         if (row.flatteningOption && 
      !this.flatteningOptionList.includes(row.flatteningOption)) {
    this.snackbar.open(
      `Invalid Flattening Option "${row.flatteningOption}" at row ${i + 1}`, 
      "OK", 
      { duration: 5000 }
    );
    return; 
  }
    if (row.orderId !== undefined && row.orderId !== null) {
		const orderIdNum = Number(row.orderId);
		if (!Number.isInteger(orderIdNum) || orderIdNum < 0) {
		this.snackbar.open(`Order Id must be an integer at row ${i + 1}`,"OK",{ duration: 5000 });
		return;
		}
	}
  if(row.objectGroupName){
    const errorMsg =  this.validateObjectGroupName(row, i);
     if (errorMsg) {
      this.snackbar.open(errorMsg, "Close", { duration: 5000 });
      return;
    }
  }
  if (row.description) {
    const errorMsg = this.validateStageField("Stage Object Name", row.description , i);
    if (errorMsg) {
      this.snackbar.open(errorMsg, "Close", { duration: 5000 });
      return;
    }
  }

  // validate Stage Object Label
  if (row.datasetname) {
    const errorMsg = this.validateStageField("Stage Object Label", row.datasetname, i);
    if (errorMsg) {
      this.snackbar.open(errorMsg, "Close", { duration: 5000 });
      return;
    }
  }
    const refError = this.validateReferenceColumns(row, i);
    if (refError) {
      this.snackbar.open(refError, "Close", { duration: 5000 });
      return; 
    }
      }
      const mappingType = (row.mapping_type || '').toLowerCase();
        const isAllowedEmptyTarget = ['no mapping'].includes(mappingType);
        const isAllowedEmptySource = ['functional mapping', 'direct mapping'].includes(mappingType);
      for (const field of manditoryFields) {
        if (!row[field] || (typeof row[field] === 'string' && row[field].trim() === '')) {
            if(this.data.edata === 'stageobjects'){
              const fieldLabel = this.fieldLabelMap[field] || field;
              this.snackbar.open(`Field "${fieldLabel}" is mandatory and missing in row ${i + 1}`, 'Close', {duration:5000});
              return
            }
            if (field === 'target_attribute' && isAllowedEmptyTarget) {
                 continue; // skip the error, it's okay
            }  
            if (field === 'source_attribute' && isAllowedEmptySource) {
                 continue; // skip the error, it's okay
            }  
          this.snackbar.open(`Field "${field}" is mandatory and missing in row ${i + 1}`, 'Close', {
            duration: 3000,
          });
          return; // stop save if any mandatory field missing
        }
        if (field === 'attributes' && Array.isArray(row[field]) && row[field].length === 0) {
          this.snackbar.open(`Field "attributes" is mandatory and empty in row ${i + 1}`, 'Close', {
            duration: 3000,
          });
          return; // stop save
        }
          //  Custom validation for target_attribute: must contain only one value

           if (field === 'target_attribute' &&   !isAllowedEmptyTarget && 
        row[field]) {
        const targetAttrStr = typeof row[field] === 'string' ? row[field] : JSON.stringify(row[field]);
        const targets = targetAttrStr.split(',').map(s => s.trim()).filter(s => s);

        if (targets.length !== 1) {
          this.snackbar.open(`"target_attribute" must contain only one value  instead of multiple in row ${i + 1}`, 'Close', { duration: 3000 });
          return;
        }
      }
       // 2 CONDITIONAL VALIDATION for target_attribute
    //    const mappingType = (row['mapping_type'] || '').toLowerCase();
    // if (!['direct mapping','functional mapping'].includes(mappingType)) {
    //   if (!row['target_attribute'] || (typeof row['target_attribute'] === 'string' && row['target_attribute'].trim() === '')) {
    //     this.snackbar.open(`Field "target_attribute" is mandatory when mapping_type is "${row['mapping_type']}" in row ${i + 1}`, 'Close', {
    //       duration: 3000,
    //     });
    //     return;
    //   }
    
    //   const targetAttrStr = typeof row['target_attribute'] === 'string' 
    //     ? row['target_attribute'] 
    //     : JSON.stringify(row['target_attribute']);
    //   const targets = targetAttrStr.split(',').map(s => s.trim()).filter(s => s);
    //   if (targets.length !== 1) {
    //     this.snackbar.open(`"target_attribute" must contain only one value for mapping_type "${row['mapping_type']}" in row ${i + 1}`, 'Close', {
    //       duration: 3000,
    //     });
    //     return;
    //   }
    // }
     
      
      if(field === 'mapping_type'){
        if (row[field] && row[field].toLowerCase() === 'codelist mapping'.toLowerCase()) {
          if(!row['codelistname'] || row['codelistname'].trim() ===''){
            this.snackbar.open(`"Codelistname" is mandatory when mappingtype is "Codelist Mapping" in row ${i + 1}`, 'Close', {
              duration: 3000,
            });
            return;
          }
          if(!row['codelist_value_type'] || row['codelist_value_type'].trim() ===''){
            this.snackbar.open(`"codelist_value_type" is mandatory when mappingtype is "Codelist Mapping" in row ${i + 1}`, 'Close', {
              duration: 3000,
            });
            return;
          }
        }
        if (row[field] && row[field].toLowerCase() === 'functional mapping'.toLowerCase()) {
          if(!row['mapping_logic'] || row['mapping_logic'].trim() ===''){
            this.snackbar.open(`"Transformation Expression" is mandatory when mappingtype is "Functional Mapping" in row ${i + 1}`, 'Close', {
              duration: 3000,
            });
            return;
          }
          const refSourceObject = row['reference_source'];
          if(refSourceObject && typeof refSourceObject === 'string'){
            console.log("*************************************")
            console.log(this.sourceObjectNameSet)
            console.log(refSourceObject)
             const refSourceObjectName = refSourceObject.split(',').map(obj =>obj.trim().toLocaleLowerCase());
              for(const name of refSourceObjectName){
                console.log(name)
              if(!this.sourceObjectNameSet.has(name)){
                this.snackbar.open(`Row ${i + 1}: Reference Source Object "${name}" not found in source objects list.`, 'Close', { duration: 5000 });
                return
             }
             }
          }
          const refGlobalObj = row['reference_global_object'];
          if(refGlobalObj && typeof refGlobalObj === 'string'){
            console.log(refGlobalObj)
             const refGlobalObjectName = refGlobalObj.split(',').map(obj => obj.trim().toLowerCase());
             for(const name of refGlobalObjectName){
              console.log(name)
                    const existedreferenceGlobal = this.referenceGlobalObjectsList
        .some(obj => obj.objectname && obj.objectname.toLowerCase().trim() === name);
              if(!existedreferenceGlobal){
                this.snackbar.open(`Row ${i + 1}: Reference Global Object "${name}" not found in global objects list.`, 'Close', { duration: 5000 });
                return
             }
             }
          }
          const refTargetObj = row['reference_target']
          if(refTargetObj && typeof refTargetObj === 'string'){
             const refTargetObjectName = refTargetObj.split(',').map(obj => obj.trim().toLowerCase());
             for(const name of refTargetObjectName){
              const existedreferencetarget = this.mappingConfigurationData.some(obj =>obj.combined && obj.combined.toLowerCase().trim() === name);
              if(!existedreferencetarget){
                this.snackbar.open(`Row ${i + 1}: Reference Target Object "${name}" not found in target objects list.`, 'Close', { duration: 5000 });
                return
             }
             }
          }

          const refLibraryObj = row['reference_vault_object']
          if(refLibraryObj && typeof refLibraryObj === 'string'){
             const refLibraryObjectName = refLibraryObj.split(',').map(obj => obj.trim().toLowerCase());
             for(const name of refLibraryObjectName){
              console.log(name)
              console.log(this.referenceLibraryObjectsList)
               const existedRefLibraryobject = this.referenceLibraryObjectsList.some(obj=> obj.objectname && obj.objectname.trim().toLowerCase()===name)
              if(!existedRefLibraryobject){
                this.snackbar.open(`Row ${i + 1}: Reference Library Object "${name}" not found in target objects list.`, 'Close', { duration: 5000 });
                return
             }
             }
          }
          const refGlobalSourceObj = row['reference_global_source_library']
           if(refGlobalSourceObj && typeof refGlobalSourceObj === 'string'){
             const refGlobalSourceObjectName = refGlobalSourceObj.split(',').map(obj => obj.trim().toLowerCase());
             for(const name of refGlobalSourceObjectName){
                const existedRefGlobalSourceObj = this.referenceSourceGlobalObjectsList
                  .some(obj => obj.objectname && obj.objectname.trim().toLowerCase() === name);
              if(!existedRefGlobalSourceObj){
                this.snackbar.open(`Row ${i + 1}: Reference Global Source Object "${name}" not found in source objects list.`, 'Close', { duration: 5000 });
                return
             }
             }
          }

          const globalExternalObj = row['global_external_object']
          if(globalExternalObj && typeof globalExternalObj === 'string'){
             const globalExternalObjectName = globalExternalObj.split(',').map(obj => obj.trim().toLowerCase());
             console.log(this.referenceExternalObjectsList)
             for(const name of globalExternalObjectName){
                const existedreferencetarget = this.referenceExternalObjectsList.some(obj =>obj.objectname && obj.objectname.toLowerCase().trim() === name);
              if(!existedreferencetarget){
                this.snackbar.open(`Row ${i + 1}: Global External Object "${name}" not found in source objects list.`, 'Close', { duration: 5000 });
                return
             }
             }
          }

          const referenceValueMapping = row['reference_library']
          if(referenceValueMapping && typeof referenceValueMapping === 'string'){
             const refValueMapping = referenceValueMapping.split(',').map(obj => obj.trim().toLowerCase());
             for(const name of refValueMapping){
                const existedreferencetarget = this.codeListData.some(obj =>obj.mappingTypeName && obj.mappingTypeName.toLowerCase().trim() === name);
              if(!existedreferencetarget){
                this.snackbar.open(`Row ${i + 1}: Reference Value Mapping "${name}" not found in Library List.`, 'Close', { duration: 5000 });
                return
             }
             }
          }

          
          const reference_Database_Object_Name = row['reference_Database_Object_Name']
          if(reference_Database_Object_Name && typeof reference_Database_Object_Name === 'string'){
             const ref_Database_Object_Name = reference_Database_Object_Name.split(',').map(obj => obj.trim().toLowerCase());
             for(const name of ref_Database_Object_Name){
                const existed_ref_Database_Object_Name = this.referenceTargetObjectsList.some(obj =>obj.objectname && obj.objectname.toLowerCase().trim() === name);
              if(!existed_ref_Database_Object_Name){
                this.snackbar.open(`Row ${i + 1}: Reference DB Object Name "${name}" not found in Target Object List`, 'Close', { duration: 5000 });
                return
             }
             }
          }

          const reference_Database_Object_Fetch_Partial = row['reference_Database_Object_Fetch_Partial']
          if(reference_Database_Object_Fetch_Partial && typeof reference_Database_Object_Fetch_Partial === 'string'){
             const ref_Database_Object_Fetch_Partial = reference_Database_Object_Fetch_Partial.split(',').map(obj => obj.trim().toLowerCase());
             for(const name of ref_Database_Object_Fetch_Partial){
                const existed_ref_Database_Object_Fetch_Partial = this.referenceTargetObjectsList.some(obj =>obj.objectname && obj.objectname.toLowerCase().trim() === name);
              if(!existed_ref_Database_Object_Fetch_Partial){
              
                 this.snackbar.open(`Row ${i + 1}: Reference DB Object Fetch Partials "${name}" not found in Target Object List.`, 'Close', { duration: 5000 });
                return
             }
             }
          }

        }
         if (row[field] && row[field].toLowerCase() === 'concat mapping'.toLowerCase()) {
          if(!row['query'] || row['query'].trim() ===''){
            this.snackbar.open(`"Query" is mandatory when mappingtype is "Concat Mapping" in row ${i + 1}`, 'Close', {
              duration: 3000,
            });
            return;
          }
           row.mapping_logic= row.query;
        }
        if (row[field] && row[field].toLowerCase() === 'lookup mapping'.toLowerCase()) {
          if(!row['codelist_value_type'] || row['codelist_value_type'].trim()===''){
            this.snackbar.open(`"codelist_value_type" is mandatory when mappingtype is "Lookup Mapping" in row ${i + 1}`, 'Close', {
              duration: 3000,
            });
            return;
          }
          if(!row['selected_object'] || row['selected_object']===''){
            this.snackbar.open(`"selected_object" is mandatory when mappingtype is "Lookup Mapping" in row ${i + 1}`, 'Close', {
              duration: 3000,
            });
            return;
          }
          if(!row['selected_attributes'] || row['selected_attributes'] ===''){
            this.snackbar.open(`"selected_attributes" is mandatory when mappingtype is "Lookup Mapping" in row ${i + 1}`, 'Close', {
              duration: 3000,
            });
            return;
          }
          if (!row['query'] || row['query'].trim() === '') {
            this.snackbar.open(`"query" is mandatory when mappingtype is "Lookup Mapping" in row ${i + 1}`, 'Close', {
              duration: 3000,
            });
            return;
          }
           const selectedObjects = row['selected_object']. split(',').map(obj =>obj.trim().toLowerCase())
          const selectedAttrs = Array.isArray(row['selected_attributes'])
            ? row['selected_attributes']
            : row['selected_attributes'].split(',').map((a: string) => a.trim());
          const queries = row['query'].split(',').map(q => q.trim());
           const referenceSources = row['reference_source'] ? row['reference_source'].split(',').map(obj => obj.trim().toLowerCase()) : [];
          const referenceTargets = row['reference_target'] ? row['reference_target'].split(',').map(obj => obj.trim().toLowerCase()) : [];
          const referenceLibraries = row['reference_library'] ? row['reference_library'].split(',').map(obj => obj.trim().toLowerCase()) : [];
          for (const selected of selectedObjects) {
            const isInSource = referenceSources.includes(selected);
            const isInTarget = referenceTargets.includes(selected);
            const isInLibrary = referenceLibraries.includes(selected);
            if (!isInSource && !isInTarget && !isInLibrary) {
              this.snackbar.open(
                `Row ${i + 1}: Selected object "${selected}" must be present in reference_source, reference_target, or reference_library.`,
                'Close',
                { duration: 5000 }
              );
              return;
            }
          }
          if(selectedObjects.length !== selectedAttrs.length || selectedAttrs.length !==queries.length){
            this.snackbar.open(`Row ${i + 1}: "selected_object", "selected_attributes", and "query" must have the same number of comma-separated values.`, 'Close', { duration: 5000 });
            return;
          }
          const logicParts: string[] = []
           for (let j = 0; j < selectedObjects.length; j++) {
            const selectedObject = selectedObjects[j];
            const selectedAttr = selectedAttrs[j].trim().toLowerCase();
            const query = queries[j];

            let objectType = '';
            let foundObject: any = null;

            if (referenceSources.includes(selectedObject)) {
              objectType = 'Source';
              foundObject = this.sourceObjectsList.find(obj => obj.objectname?.toLowerCase().trim() === selectedObject);
            } else if (referenceTargets.includes(selectedObject)) {
              objectType = 'Target';
              foundObject = this.referenceTargetObjectsList.find(obj => obj.objectname?.toLowerCase().trim() === selectedObject);
            } else if (referenceLibraries.includes(selectedObject)) {
              objectType = 'Library';
              foundObject = this.codeListData.find(obj =>
                obj.objectname?.toLowerCase().trim() === selectedObject ||
                obj.mappingTypeName?.toLowerCase().trim() === selectedObject
              );
            } else {
              this.snackbar.open(`Row ${i + 1}: Selected object "${selectedObject}" is not listed in reference_source, reference_target, or reference_library.`, 'Close', { duration: 5000 });
              return;
            }

            if (!foundObject) {
              this.snackbar.open(`Row ${i + 1}: Selected object "${selectedObject}" not found in ${objectType} list.`, 'Close', { duration: 5000 });
              return;
            }

            let allowedAttrNames: string[] = [];

            try {
              console.log(`Parsed object for ${selectedObject}:`, foundObject);
              const parsedAttrs = JSON.parse(foundObject.objectattributes || '{}');
              if (Array.isArray(parsedAttrs)) {
                allowedAttrNames = parsedAttrs.map(attr => attr.name?.toLowerCase().trim()).filter(Boolean);
                console.log(`Allowed attributes for ${selectedObject}:`, allowedAttrNames);
              } else if (parsedAttrs.datasets) {
                parsedAttrs.datasets.forEach((ds: any) => {
                  if (Array.isArray(ds.columns)) {
                    ds.columns.forEach((col: any) => {
                      if (col.name) allowedAttrNames.push(col.name.toLowerCase().trim());
                    });
                  }
                });
              }
            } catch (e) {
              console.warn(`Row ${i + 1}: Failed to parse objectattributes for "${selectedObject}"`);
            }

            if (!allowedAttrNames.includes(selectedAttr.toLowerCase())) {
              this.snackbar.open(`Row ${i + 1}: Attribute "${selectedAttr}" not found in ${objectType} object "${selectedObject}"`, 'Close', { duration: 5000 });
              return;
            }

            const prefix = j === 0 ? '' : 'Lookup:';
            logicParts.push(`${prefix}${selectedObject},${selectedAttr},${query}`);
          }

          row.mapping_logic = logicParts.join(';');
           const validReferenceObjects: string[] =[]
          const refSourceObject = row['reference_source'];
          if(refSourceObject && typeof refSourceObject === 'string'){
            console.log("*************************************")
            console.log(this.sourceObjectNameSet)
            console.log(refSourceObject)
             const refSourceObjectName = refSourceObject.split(',').map(obj =>obj.trim().toLocaleLowerCase());
            
             const label = 'Source';
              for(const name of refSourceObjectName){
                console.log(name)
              if(!this.sourceObjectNameSet.has(name)){
                this.snackbar.open(`Row ${i + 1}: Reference Source Object "${name}" not found in source objects list.`, 'Close', { duration: 5000 });
                return
             }else{
                validReferenceObjects.push(`${name}:${label}`)
              // this.refSourceObjectsListForLookup = name+":Source"
             }
             }
          }
          const refTargetObj = row['reference_target']
          if(refTargetObj && typeof refTargetObj === 'string'){
             const refTargetObjectName = refTargetObj.split(',').map(obj => obj.trim().toLowerCase());
            
             const label = 'Target';
             for(const name of refTargetObjectName){
              const existedreferencetarget = this.referenceTargetObjectsList.some(obj =>obj.objectname && obj.objectname.toLowerCase().trim() === name);
              if(!existedreferencetarget){
                this.snackbar.open(`Row ${i + 1}: Reference Target Object "${name}" not found in target objects list.`, 'Close', { duration: 5000 });
                return
             }else{
              validReferenceObjects.push(`${name}:${label}`)
             }
             }
          }
           const refLibraryObj = row['reference_library']
          if(refLibraryObj && typeof refLibraryObj === 'string'){
             const refLibraryObjectName = refLibraryObj.split(',').map(obj => obj.trim().toLowerCase());
             console.log(refLibraryObj)
             const label = 'ValueMapping';
             for(const name of refLibraryObjectName){
              console.log("****************")
              console.log(name)
               const existedRefLibraryobject = this.referenceTargetObjectsList.some(obj=> obj.objectname && obj.objectname.trim().toLowerCase())
              if(!existedRefLibraryobject){
                this.snackbar.open(`Row ${i + 1}: Reference Library Object "${name}" not found in target objects list.`, 'Close', { duration: 5000 });
                return
             }else{
                validReferenceObjects.push(`${name}:${label}`)
             }
             }
          }
          row['lookupMappingDetails'] = validReferenceObjects.join(',');
          row['reference_source'] = '';
          row['reference_target'] = '';
          row['reference_library'] = '';
          // if (!allowedAttrNames) {
          //   this.snackbar.open(`Row ${i + 1}: Selected object "${row['selected_object']}" not found`, 'Close', { duration: 4000 });
          //   return;
          // }
          //  for (const attr of selectedAttrs) {
          //   if (!allowedAttrNames.includes(attr.toLowerCase().trim())) {
          //     this.snackbar.open(`Row ${i + 1}: Attribute "${attr}" not found in object "${row['selected_object']}"`, 'Close', {
          //       duration: 4000,
          //     });
          //     return;
          //   }
          // }
            // let combinedAttributes: string;

            // if (Array.isArray(row.selected_attributes)) {
            //    combinedAttributes = row.selected_attributes.join(', ');
            //   } else {
            //      combinedAttributes = row.selected_attributes ?? ""; // fallback if undefined
            //   }
  
        // row.mapping_logic = `${row.selected_object},${combinedAttributes},${row.query}`;
    
        }
      }
     }
     const trueFalseFieldsMap: { [key: string]: string[] } = {
      deferred: ['yes', 'no', 'true', 'false',''],
      isloadable:['yes', 'no', 'true', 'false',''],
      isParent:['yes', 'no', 'true', 'false',''],
      
      requiresglobalobject: ['yes', 'no', 'true', 'false'],
      
    };
     const yesNoFieldsMap: { [key: string]: string[] } = {
      vaultextraction: ['yes', 'no', 'true', 'false'],
      setssplitrequired: ['yes', 'no', 'true', 'false'],
      isExecutable__j:['yes', 'no', 'true', 'false'],
      attachmentquery__j:['yes', 'no', 'true', 'false'],
     }
    const positiveNumberFields: string[] = ['loadorder', 'executionorder__j'];

       for (const [fieldName, allowedValues] of Object.entries(yesNoFieldsMap)) {
         if (fieldName in row) {
             const raw = row[fieldName];
           const rawVal = (typeof raw === 'boolean') ? raw.toString() : (raw || '').toString().trim().toLowerCase();
            if (!allowedValues.includes(rawVal)) {
            this.snackbar.open(`Invalid value "${row[fieldName]}" for "${fieldName}" in row ${i + 1}. Allowed: ${allowedValues.join(', ')}`, 'Close', {
            duration: 4000,
            });
            return;
            }
          }
     
        }
          for (const field of positiveNumberFields) {
            if (field in row) {
              const raw = row[field];
              if (raw !== null && raw !== undefined && raw !== '') {
                  const val = Number(raw);
                  if (isNaN(val) || val <= 0) {
                     this.snackbar.open(`"${field}" must be a positive number in row ${i + 1}`, 'Close', {
                      duration: 4000,
                       });
                  return;
                  }
               }
            }
          }
          for( let row of this.rowData){
              for (const field of Object.keys(trueFalseFieldsMap)){
               if (field in row){
                   row[field] = this.parseBoolean(row[field]);
               }
               for(const field of Object.keys(yesNoFieldsMap)){
                   if (field in row){
                   row[field] = this.parseBooleanForYesOrNo(row[field]);
               }
               }
             }
          }
  
    }

    if (this.data.edata === 'loadobjectsmstr') {

  this.spinner.start();

  this.ensureFileNameListLoaded()
    .then(() => {

      for (let i = 0; i < this.rowData.length; i++) {
        const row = this.rowData[i];

        const mappingId = this.resolveMappingIdFromFileName(row.fileName);

        if (!mappingId) {
          this.spinner.stop();
          this.snackbar.open(
            `Row ${i + 1}: Invalid File Name "${row.fileName}". Mapping Configuration not found.`,
            'Close',
            { duration: 6000 }
          );
          return;
        }

        row.mappingconfigurationid = mappingId;
      }

      this.sendExcelData(this.rowData);
      this.spinner.stop();
    })
    .catch(() => {
      this.spinner.stop();
      this.snackbar.open(
        'Failed to load File Name mapping configuration.',
        'Close',
        { duration: 5000 }
      );
    });

  return; 
}

    // this.sendExcelData(this.rowData);
    if(this.data.edata === 'stageobjects'){
  //     if (this.data.edata === 'stageobjects' && this.uniquenessErrors?.length > 0) {
  //   this.snackbar.open(` Conflicts detected. Please fix uniqueness errors.`,"OK",{ duration: 5000 });
  // //    const errorMessages = this.uniquenessErrors
  //   .map(e => `[${e.dataset}] ${e.message}`)
  //   .join("\n");

  // this.snackbar.open(
  //   `Cannot save due to conflicts:\n${errorMessages}`,
  //   "OK",
  //   { duration: 6000 }
  // );
    // console.warn("Uniqueness errors:", this.uniquenessErrors);
    // return; // stop save
    // }
      this.sendExcelData(this.validStageJsons)
    }else{
      
      this.sendExcelData(this.rowData);
    }
  }
 
    cancel(){
      this.dialogref.close()
    }
    
    
        /**
	 * @Author: Venkata Shyam
	 * @Date:18-06-2025
	 * @description: This method will retrieve the information of source and target based on login workspace
	 */ 
async retrieveSourceAndTargetInfo(){
  const workspaceId = this.localStorageSettings.getSettings("WorkspaceId")
    this.spinner.start();
      this.commonService.retrieveDnsInfo(workspaceId).subscribe(async (response) => {
        console.log(response);
        if (response.error == true) {
          this.spinner.stop();
          this.snackbar.open(response.statusMessage, 'OK', { duration: 5000 });
          return null;
        } else {
          // this.spinner.stop();
          const dnsInfoList = response;

  // Iterate and extract specific fields if needed
  dnsInfoList.forEach((item) => {
    console.log("Environment Name:", item.envname);
    console.log("DNS Name:", item.dnsname);
    console.log("Session ID:", item.sessionid);
    console.log("Tenant ID:", item.tenantid);
    // Access other fields as needed
  });

  // Or store it in a variable to use in HTML
    // const dnsDataArray = dnsInfoList;
    const dnsDataArray = response.map(item => ({
      id: item.vaultId,                         // backend vaultId → id
      name: item.envname,                       // envname → name
      source: item.dnsname,                     // dnsname → source (or sourceDnsId?)
      sourceDnsId: item.vaultconfigmstrid,     // vaultconfigmstrid → sourceDnsId
      target: item.dnsname,                     // dnsname again? Or from another field?
      targetDnsId: item.tenantid,               // tenantid → targetDnsId
      url: `https://${item.envname}/api`,
      sourceType:item.sourceType||null         // construct URL from envname or another field
    }));
    console.log(dnsDataArray)

    const sourceInfo = dnsDataArray.filter(obj=>
      obj.source.startsWith('Source_')
    )
    const targetInfo = dnsDataArray.filter(obj=>
      obj.source.startsWith('Target_')
    )
    this.sourceDetails = sourceInfo
      this.targetDetails = targetInfo
      console.log(this.sourceDetails)
      console.log(this.targetDetails)
      await this.retrieveSourceObjects()
      await this.retrieveTargetObjects()
      // this.spinner.stop();
  }
});

}

        /**
	 * @Author: Venkata Shyam
	 * @Date:18-06-2025
	 * @descrition: This method will retrieve all the source objects from objectmetadata based on source id
	 */ 
retrieveSourceObjects(){
  // this.spinner.start();
  const primarySource=this.sourceDetails.filter(obj=>obj.sourceType=="primary")
  const sourceId = primarySource.map(item=>item.sourceDnsId)
  console.log(this.sourceDetails);
  this.reportingService.retrieveObjectsByMultipleDnsId(sourceId).subscribe({
    next: (res: any) => {
        console.log("Subscribe Response:", res);

        if (res.error === true) {
          console.log("erro*******************")
            // this.ObjectGrid.api.setGridOption('rowData', []);
        } else {
            this.sourceObjectsList = res;
            console.log(res);
            this.sourceObjectsLoaded = true;
            // this.tryCompareObjects();
            const objects = res.map((item: any, index: number) => ({
                id: item.id || index, // Assign index if id is missing
                objectlabel: item.objectlabel || item,
                objectname: item.objectname || ""
            }));
            this.commonService.getlookupVauleByLookUpType("Vault Object Group").subscribe(result => {
                  console.log(result);
                  // this.mappingTypeDataDropDown = result;
                  // console.log(this.mappingTypeDataDropDown)
                  let lookupDetails:any=result
                   let ExternalLookupValue=lookupDetails.filter(item=>item.lookupcode=="External")
                  this.referenceLibraryObjectsLookupValue=lookupDetails.filter(item=>item.lookupcode=="Library");
                  this.referenceGlobalObjectsLookupValue=lookupDetails.filter(item=>item.lookupcode=="Global");
                  console.log(ExternalLookupValue);
                  let lookupValueId=ExternalLookupValue[0].lookupvalueid
                  const externalObjects = res.filter(item=>item.objecttype == lookupValueId);
                  console.log(externalObjects);
                  console.log("*****************************");
                  
                   this.referenceExternalObjectsList=externalObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                let globalLookupId=this.referenceGlobalObjectsLookupValue[0].lookupvalueid
                const globalObjects=res.filter(item=>item.objecttype == globalLookupId);
                this.referenceSourceGlobalObjectsList=globalObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                 })
                 console.log(this.referenceExternalObjectsList)
                 

            // console.log("Mapped Objects for Grid:", objects);
            // this.ObjectGrid.api.setGridOption('rowData', objects);
            // this.ObjectGrid.api.forEachNode(node=>{      
            //   console.log("objectlabel:"+node.data['objectlabel'])
            //   console.log(node.data.objectlabel+"============="+this.mappingCreationData.stageobject)
            //   if(node.data['objectname']===this.mappingCreationData.stageobject){
            //     console.log("dns")
            //        node.setSelected(true)
            //        this.ObjectGrid.api.ensureNodeVisible(node);
            //   }
            // })
        }
    },
    error: (error) => {
        console.error("API Error:", error);
        this.snackbar.open("Error retrieving data", "OK", { duration: 5000 });
        // this.spinner.stop();
    },
    complete: () => {
        // this.spinner.stop();
    }
});
}
     /**
	 * @Author: Venkata Shyam
	 * @Date:18-06-2025
	 * @descrition: This method will retrieve all the target objects from objectmetadata based on target id
	 */ 
retrieveTargetObjects(){
  const sourceId = this.targetDetails.map(item=>item.sourceDnsId)
  // this.spinner.start();
  this.commonService.retrieveObjectGroupObjectsbasedDns(sourceId).subscribe({
    next: (res: any) => {
        console.log("Subscribe Response:", res);

        if (res.error === true) {
          console.log("erro*******************")
            // this.ObjectGrid.api.setGridOption('rowData', []);
        } else {
            this.TargetObjectsList = res;
            console.log(res);
            this.targetObjectsLoaded = true;
            // this.tryCompareObjects();
            const objects = res.map((item: any, index: number) => ({
                id: item.id || index, // Assign index if id is missing
                objectlabel: item.objectlabel || item,
                objectname: item.objectname || ""
            }));
            
            this.commonService.getlookupVauleByLookUpType("Vault Object Group").subscribe(lookupResult => {
          let lookupDetails: any = lookupResult;

          this.referenceLibraryObjectsLookupValue = lookupDetails.filter((item: any) => item.lookupcode == "Library");
          this.referenceGlobalObjectsLookupValue = lookupDetails.filter((item: any) => item.lookupcode == "Global");

          
          this.getTargetReferenceObjects();
        });
            // this.compareObject()
            // console.log("Mapped Objects for Grid:", objects);
            // this.ObjectGrid.api.setGridOption('rowData', objects);
            // this.ObjectGrid.api.forEachNode(node=>{      
            //   console.log("objectlabel:"+node.data['objectlabel'])
            //   console.log(node.data.objectlabel+"============="+this.mappingCreationData.stageobject)
            //   if(node.data['objectname']===this.mappingCreationData.stageobject){
            //     console.log("dns")
            //        node.setSelected(true)
            //        this.ObjectGrid.api.ensureNodeVisible(node);
            //   }
            // })
        }
    },
    error: (error) => {
        console.error("API Error:", error);
        this.snackbar.open("Error retrieving data", "OK", { duration: 5000 });
        this.spinner.stop();
    },
    complete: () => {
        // this.spinner.stop();
    }
});
}

 getTargetReferenceObjects(){
         const targetDnsid = this.targetDetails.map(item=>item.sourceDnsId)
        this.commonService.retrieveNonStageObjectsbasedDns(targetDnsid).subscribe(res=>{
            if (res.error === true) {
                // this.ObjectGrid.api.setGridOption('rowData', []);
                 this.spinner.stop();
            } else {
              
                console.log(res);
                const objects = res.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                  this.referenceTargetObjectsList = res;
                       let lookupValueId=this.referenceLibraryObjectsLookupValue[0].lookupvalueid
                  const LibraryObjects = res.filter(item=>item.objecttype == lookupValueId);
                  
                   this.referenceLibraryObjectsList=LibraryObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                console.log(this.referenceLibraryObjectsList);

                 let globalLookupValueId=this.referenceGlobalObjectsLookupValue[0].lookupvalueid
                  const GlobalObjects = res.filter(item=>item.objecttype == globalLookupValueId);
                  
                   this.referenceGlobalObjectsList=GlobalObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                  //  this.spinner.stop();            
                   this.spinner.stop();
            }
            
    });
  }
     /**
	 * @Author: Venkata Shyam
	 * @Date:18-06-2025
	 * @descrition: This method will compare the source and target objects then finds the exact match for 
   * each reacord of source and target combination and it's associated information of id's of both sourceand target
   * objects and dns of both and creates a mapping configuration. So after creation of mapping configuration it will
   * get the same data with mappingobjectid then it will be appended and constructing the source and target attributes list
   * based on matching
	 */ 

// compareObject() {
//   console.log("inside compareObject");
//   if (!this.rowData || !Array.isArray(this.rowData)) return;

//   // this.spinner.start();

//   this.mappedObjects = this.rowData.map(item => {
//     const source = this.sourceObjectsList.find(obj =>
//       obj.objectlabel.trim().toLowerCase() === item.source_object.trim().toLowerCase()
//     );
//     const target = this.TargetObjectsList.find(obj =>
//       obj.objectlabel.trim().toLowerCase() === item.target_object.trim().toLowerCase()
//     );
//     return {
//       row: item,
//       sourceMatch: source,
//       targetMatch: target
//     };
//   });
//   console.log("Mapped Results:", this.mappedObjects);

//   this.mappingDto = this.mappedObjects.map(mapped => {
//     return {
//       mappingconfigurationid: 0,
//       stageobject: mapped.sourceMatch?.objectname,
//       stageobjectid: mapped.sourceMatch?.id || null,
//       targetobject: mapped.targetMatch?.objectname,
//       targetobjectid: mapped.targetMatch?.id || null,
//       status: mapped.row.status || 'Active',
//       tenantid: this.localStorageSettings.getSettings("TenantId"),
//       sourcedns: this.sourceDetails[0]?.name || '',
//       sourcednsid: this.sourceDetails[0]?.sourceDnsId || null,
//       targetdns: this.targetDetails[0]?.name || '',
//       targetdnsid: this.targetDetails[0]?.sourceDnsId || null
//     };
//   });
//   console.log("Final Payloads for API submission:", this.mappingDto);

//   this.mappingAttributeServices.mappingSourceAndTargetObjects(this.mappingDto).subscribe((response: any) => {
    

//     if (response.error) {
//       console.error("Error:", response);
//       this.snackbar.open(response.statusMessage, "OK", { duration: 5000 });
//       return;
//     }

//     let updatedList = response;

//     const invalidMappings = updatedList.filter(item =>
//       item.mappingconfigurationid === 0 ||
//       item.stageobject === null ||
//       item.stageobjectid === null ||
//       item.targetobject === null ||
//       item.targetobjectid === null
//     ).map(item => {
//       const remarks: string[] = [];
//       if (item.mappingconfigurationid === 0) remarks.push('mappingconfigurationid is 0');
//       if (item.stageobject === null) remarks.push('stageobject is null');
//       if (item.stageobjectid === null) remarks.push('stageobjectid is null');
//       if (item.targetobject === null) remarks.push('targetobject is null');
//       if (item.targetobjectid === null) remarks.push('targetobjectid is null');

//       return {
//         ...item,
//         remarks: remarks.join(', ')
//       };
//     });
//     console.log('Invalid mappings with remarks:', invalidMappings);

//     updatedList = updatedList.filter(item =>
//       item.mappingconfigurationid !== 0 && item.mappingconfigurationid !== null
//     );
//     console.log("Valid updatedList:", updatedList);

//     updatedList.forEach((mappingItem: any) => {
//       const matchedRows = this.rowData.filter((row: any) => {
//         const source = this.sourceObjectsList.find(obj =>
//           obj.objectname === mappingItem.stageobject
//         );
//         const target = this.TargetObjectsList.find(obj =>
//           obj.objectname === mappingItem.targetobject
//         );
       

//         return (
//           row.source_object?.trim().toLowerCase() === source?.objectlabel?.trim().toLowerCase() &&
//           row.target_object?.trim().toLowerCase() === target?.objectlabel?.trim().toLowerCase() 

//         );
//       });

//      matchedRows.forEach((matchedRow) => {
//   matchedRow.mappingObjectId = mappingItem.mappingconfigurationid;
//   matchedRow.source_object_id = mappingItem.stageobjectid;
//   matchedRow.target_object_id = mappingItem.targetobjectid;

//   const sourceObj = this.sourceObjectsList.find(obj =>
//     obj.objectname === mappingItem.stageobject
//   );
//   const targetObj = this.TargetObjectsList.find(obj =>
//     obj.objectname === mappingItem.targetobject
//   );
//   console.log(sourceObj, targetObj);

//   //  Extract Source Attributes
//   let extractedAttributes: any[] = [];
//   try {
//     let parsed = typeof sourceObj?.objectattributes === 'string'
//       ? JSON.parse(sourceObj.objectattributes)
//       : sourceObj?.objectattributes;

//     if (Array.isArray(parsed)) {
//       extractedAttributes = parsed;
//     } else if (parsed?.datasets?.length) {
//       parsed.datasets.forEach(dataset => {
//         if (Array.isArray(dataset.columns)) {
//           extractedAttributes.push(...dataset.columns);
//         }
//       });
//     }
//   } catch (e) {
//     console.warn("Error parsing source objectattributes:", e);
//   }
//         let rawSource = matchedRow.source_attribute;
// let rawSourceString = '';

// if (typeof rawSource === 'string') {
//   rawSourceString = rawSource;
// } else if (Array.isArray(rawSource)) {
//   // This means it's already an array of attributes
//   rawSourceString = rawSource.map(attr => attr.name).join(',');
// }
//   // const rawSource = matchedRow.source_attribute || '';
// const cleanedSource = rawSourceString.replace(/^"|"$/g, '');
//   const selectedSourceAttributes = cleanedSource.split(',').map(label => label.trim().toLowerCase());

//   const localSourceAttributesList = extractedAttributes.filter(attr => {
//     const label = attr.name?.trim().toLowerCase() || '';
//     const baseLabel = label.includes(' (') ? label.split(' (')[0] : label;
//     return selectedSourceAttributes.includes(baseLabel);
//   });
//   console.log("Filtered Source Attributes:", localSourceAttributesList);

//   //  Extract Target Attributes
//   let targetExtractedAttributes: any[] = [];
//   try {
//     let parsed = typeof targetObj?.objectattributes === 'string'
//       ? JSON.parse(targetObj.objectattributes)
//       : targetObj?.objectattributes;

//     if (Array.isArray(parsed)) {
//       targetExtractedAttributes = parsed;
//     } else if (parsed?.datasets?.length) {
//       parsed.datasets.forEach(dataset => {
//         if (Array.isArray(dataset.columns)) {
//           targetExtractedAttributes.push(...dataset.columns);
//         }
//       });
//     }
//   } catch (e) {
//     console.warn("Invalid target attributes JSON:", e);
//   }

//   const rawTarget = matchedRow.target_attribute || '';
//   const cleanedTarget = rawTarget.replace(/^"|"$/g, '');
//   const selectedTargetAttributes = cleanedTarget.split(',').map(label => label.trim().toLowerCase());

//   const localTargetAttributesList = targetExtractedAttributes.filter(attr => {
//     const label = attr.name?.trim().toLowerCase() || '';
//     const baseLabel = label.includes(' (') ? label.split(' (')[0] : label;

//     return selectedTargetAttributes.includes(baseLabel);
//   });
//   console.log("Filtered Target Attributes:", localTargetAttributesList);

//   //  Attach to the matchedRow
//   matchedRow.source_attribute = localSourceAttributesList;
//   matchedRow.target_attribute_list = localTargetAttributesList;
// });

//     });
//     this.rowData = [...this.rowData];
//     console.log("Updated rowData:", this.rowData);
//     this.showbutton = true;
//     // this.spinner.stop()
//   });
// }

compareObject() {
  console.log("inside compareObject");
  if (!this.rowData || !Array.isArray(this.rowData)) return;

  // this.spinner.start();
console.log("spinner started")
  //  Build quick lookup maps
  const sourceMap = new Map(
    this.sourceObjectsList.map(obj => [obj.objectname.trim().toLowerCase(), obj])
  );
  const targetMap = new Map(
    this.TargetObjectsList.map(obj => [obj.objectname.trim().toLowerCase(), obj])
  );

  //  Pre-parse object attributes for quick access
  const parsedSourceAttributes = new Map();
  this.sourceObjectsList.forEach(obj =>
    parsedSourceAttributes.set(obj.objectname, this.parseAttributes(obj.objectattributes))
  );
  const parsedTargetAttributes = new Map();
  this.TargetObjectsList.forEach(obj =>
    parsedTargetAttributes.set(obj.objectname, this.parseAttributes(obj.objectattributes))
  );

  //  Build the mapping DTO
  const mappingDtos = this.rowData.map(item => {
    const source = sourceMap.get(item.source_object?.trim().toLowerCase());
    const target = targetMap.get(item.target_object?.trim().toLowerCase());
 const primarySource=this.sourceDetails.filter(obj=>obj.sourceType=="primary")
  const sourceId = primarySource.map(item=>item.sourceDnsId)
    return {
      mappingconfigurationid: 0,
      stageobject: (source as any)?.objectname,
      stageobjectid: (source as any)?.id ?? null,
      targetobject: (target as any)?.objectname,
      targetobjectid: (target as any)?.id ?? null,
      status: item.status || 'Active',
      tenantid: this.localStorageSettings.getSettings("dnsName"),
      sourcedns: primarySource[0]?.name || '',
      sourcednsid: sourceId[0] ?? null,
      targetdns: this.targetDetails[0]?.name || '',
      targetdnsid: this.targetDetails[0]?.sourceDnsId ?? null
    };
  });
  console.log("Final Payloads for API submission:", mappingDtos);

  //  Call the service
  this.mappingAttributeServices.mappingSourceAndTargetObjects(mappingDtos).subscribe((response: any) => {
    if (response.error) {
      console.error("Error:", response);
      this.snackbar.open(response.statusMessage, "OK", { duration: 5000 });
      this.spinner.stop();
      return;
    }

    const updatedList = response;
    // this.spinner.start();
    // Identify invalid mappings
    const invalidMappings = this.getInvalidMappingsWithRemarks(response);
    console.log("Invalid mappings with remarks:", invalidMappings);

    // Keep only valid mappings
    const validList = updatedList.filter(item =>
      item.mappingconfigurationid && item.mappingconfigurationid !== 0
    );
    console.log("Valid updatedList:", validList);
    
    
    //  Final attribution and assignment
    for (const mappingItem of validList) {
      const source = this.sourceObjectsList.find(obj => obj.objectname === mappingItem.stageobject);
      const target = this.TargetObjectsList.find(obj => obj.objectname === mappingItem.targetobject);

      const sourceAttributesList = parsedSourceAttributes.get(source?.objectname);
      const targetAttributesList = parsedTargetAttributes.get(target?.objectname);

      // Find matching rows in rowData
      const matchedRows = this.rowData.filter(row =>
        row.source_object.trim().toLowerCase() === source?.objectname.trim().toLowerCase() &&
        row.target_object.trim().toLowerCase() === target?.objectname.trim().toLowerCase()
      );

      // Enhance matchedRows
      for (const matchedRow of matchedRows) {
        matchedRow.mappingObjectId = mappingItem.mappingconfigurationid;
        matchedRow.source_object_id = mappingItem.stageobjectid;
        matchedRow.target_object_id = mappingItem.targetobjectid;

        matchedRow.source_attribute = this.filterAttributes(
          matchedRow.source_attribute,
          sourceAttributesList
        );
        matchedRow.target_attribute_list = this.filterAttributes(
          matchedRow.target_attribute,
          targetAttributesList
        );
      }
    }
    
    this.rowData = this.rowData.map(row => {
  

  return {
    ...row,
    lookupMappingDetails: '' // optional backup
   
  };
});
    // Final Output
    this.rowData = [...this.rowData];

    console.log("Updated rowData:", this.rowData);
    this.showbutton = true;
    this.spinner.stop();
    // this.cdr.detectChanges();
    console.log("spinner stopped")
  });
}


parseAttributes(attributes: any): any[] {
  try {
    let parsed = typeof attributes === 'string' ? JSON.parse(attributes) : attributes;

    if (Array.isArray(parsed)) {
      return parsed;
    } else if (parsed?.datasets?.length) {
      return parsed.datasets.flatMap(ds => ds.columns ?? []);
    }
    return [];
  } catch {
    return [];
  }
}

filterAttributes(rawAttributes: any, availableAttributes: any[]): any[] {
  if (!rawAttributes) return [];
  const rawString = Array.isArray(rawAttributes) ? rawAttributes.map(attr => attr.name).join(',') : rawAttributes;

  const selectedAttributes = rawString
    .replace(/^"|"$/g, '')
    .split(',')
    .map(label => label.trim().toLowerCase());

  return availableAttributes.filter(attr => {
    const label = attr.name?.trim().toLowerCase() || '';
    const baseLabel = label.includes(' (') ? label.split(' (')[0] : label;
    return selectedAttributes.includes(baseLabel);
  });
}

getInvalidMappingsWithRemarks(data: any[]): any[] {
  return data.filter(item =>
    item.mappingconfigurationid === 0 ||
    item.stageobject == null ||
    item.stageobjectid == null ||
    item.targetobject == null ||
    item.targetobjectid == null
  ).map(item => {
    const remarks: string[] = [];
    if (item.mappingconfigurationid === 0) remarks.push('mappingconfigurationid is 0');
    if (!item.stageobject) remarks.push('stageobject is null');
    if (!item.stageobjectid) remarks.push('stageobjectid is null');
    if (!item.targetobject) remarks.push('targetobject is null');
    if (!item.targetobjectid) remarks.push('targetobjectid is null');
    return { ...item, remarks: remarks.join(', ') };
  });
}



tryCompareObjects() {
  if (this.sourceObjectsLoaded && this.targetObjectsLoaded) {
    this.compareObject();
  }
}

 
  // openSaveForm() {
  //   let manditoryFields;
  //   let fieldDisplayNames;
  
  //   if (this.data.attributes == true) {
  //     manditoryFields = ['source_object', 'target_object', 'source_attribute', 'target_attribute', 'mapping_type', 'codelistname'];
  //     fieldDisplayNames = {
  //       source_object: 'Source Object',
  //       target_object: 'Target Object',
  //       source_attribute: 'Source Attributes',
  //       target_attribute: 'Target Attribute',
  //       mapping_type: 'Mapping Type',
  //       codelistname: 'Codelist Name'
  //     };
  //   } else {
  //     manditoryFields = ['objectlabel', 'objectname', 'attributes', 'primarykey', 'source'];
  //     fieldDisplayNames = {
  //       objectlabel: 'Object Label',
  //       objectname: 'Object Name',
  //       attributes: 'Attributes',
  //       primarykey: 'Primary Key',
  //       source: 'Source'
  //     };
  //   }
  
  //   for (let i = 0; i < this.rowData.length; i++) {
  //     const row = this.rowData[i];
  //     for (const field of manditoryFields) {
  //       const displayName = fieldDisplayNames[field] || field;
  
  //       // Handle empty string or null/undefined
  //       if (!row[field] || (typeof row[field] === 'string' && row[field].trim() === '')) {
  //         this.snackbar.open(`Field "${displayName}" is mandatory and missing in row ${i + 1}`, 'Close', {
  //           duration: 3000,
  //         });
  //         return;
  //       }
  
  //       // Handle empty array for `attributes`
  //       if (field === 'attributes' && Array.isArray(row[field]) && row[field].length === 0) {
  //         this.snackbar.open(`Field "${displayName}" is mandatory and empty in row ${i + 1}`, 'Close', {
  //           duration: 3000,
  //         });
  //         return;
  //       }
  //     }
  //   }
  
  //   // All validation passed
  //   this.dialogref.close(this.rowData);
  // }

  
  downloadTemplate() {
    
console.log('working');
this.templateFile = false;
if (!this.TEMPLATE_HEADERS || this.TEMPLATE_HEADERS.length === 0) {
  this.snackbar.open('No template headers available to download.', 'OK', { duration: 4000 });
  return;
}

const data = [Object.fromEntries(this.TEMPLATE_HEADERS.map(header => [header, '']))];
this.JSONToCSVConvertor(data,this.data?.edata + '_Template', true);
} 
JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
  //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
  var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
  
  var CSV = '';
  
  //This condition will generate the Label/Header
  if (ShowLabel) {
    var row = '';
  
    //This loop will extract the label from 1st index of on array
    for (var index in arrData[0]) {
  
      //Now convert each value to string and comma-seprated
      row += index + ',';
    }
  
    row = row.slice(0, -1);
  
    //append Label row with line break
    CSV += row + '\r\n';
  }
  
  //1st loop is to extract each row
  for (var i = 0; i < arrData.length; i++) {
    var row = '';
  
    //2nd loop will extract each column and convert it in string comma-seprated
    for (var index in arrData[i]) {
      row += '"' + arrData[i][index] + '",';
    }
    //add a line break after each row
    CSV += row + '\r\n';
  }
  
  if (CSV == '') {
    alert('Invalid data');
    return;
  }
  
  //Generate a file name
  var fileName = '';
  //this will remove the blank-spaces from the title and replace it with an underscore
  fileName += ReportTitle.replace(/ /g, '_');
  
  //Initialize file format you want csv or xls
  var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
  
  // Now the little tricky part.
  // you can use either>> window.open(uri);
  // but this will not work in some browsers
  // or you will not get the correct file extension
  
  //this trick will generate a temp <a /> tag
  var link = document.createElement('a');
  link.href = uri;
  
  //set the visibility hidden so it will not effect on your web-layout
  // @ts-ignore
  link.style = 'visibility:hidden';
  link.download = fileName + '.csv';
  
  //this part will append the anchor tag and remove it after automatic click
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  }

 async downloadXLSX() {
    if(this.data.edata == 'stageobjects'){
    //   const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([
    //   Object.fromEntries(this.TEMPLATE_HEADERS.map(header => [header, '']))
    //  ]);
    //   const wb: XLSX.WorkBook = XLSX.utils.book_new();
    //   XLSX.utils.book_append_sheet(wb, ws, 'Template');

    // XLSX.writeFile(wb, this.data?.edata + '_Template.xlsx');
    const emptyRow = Object.fromEntries(this.TEMPLATE_HEADERS.map(header => [header, '']));
    await this.excelService.downloadExcel(this.TEMPLATE_HEADERS,[emptyRow], this.data?.edata + '_Template');
    }else{
      this.downloadTemplate()
    }
}

       /**
	 * @Author: Venkata Shyam
	 * @Date:18-06-2025
	 * @apiNote : This method will support upload csv file functionality where it will insert the data into table based on tableName and if any duplicates
   *  are there then they are not modifying and getting back into the UI to display the same
	 */ 
excelFileUpload(event:any):void{
  console.log(event)
  //this.uploadFile = false;
  const input = event.target as HTMLInputElement
  if(!input.files && input.files.length == 0){
    this.snackbar.open("No csv file is selected","OK",{duration: 5000});
  }
  const file = input.files[0]
  const fileName = file.name
  const isCsv = fileName.endsWith(".csv")
  if(!isCsv){
    // alert('Only CSV files are allowed.');
    this.snackbar.open('Only CSV files are allowed.',"Ok",{duration:5000})
    input.value = ''
    return;
  }
  const reader = new FileReader();
  reader.onload = ()=>{
    const csvText = reader.result as string
    const lines = this.splitCSVRows(csvText);

  if (lines.length === 0) {
    alert('Empty CSV file!');
     input.value = ''
    return;
  }

  const headers = lines[0].split(',').map(h => h.trim().replace(/^"+|"+$/g, ''));
   //  Compare headers from uploaded file with expected template headers
   const isValid = this.TEMPLATE_HEADERS.every(header => headers.includes(header));
   const noExtraColumns = headers.length === this.TEMPLATE_HEADERS.length;
   if (!isValid || !noExtraColumns) {
     this.snackbar.open("Uploaded file headers do not match the template!", "OK", { duration: 5000 });
     input.value = '';
     return;
   }
 
   //  Assign headers to ag-grid column definitions
   this.columnDefs = headers.map(header => ({
     headerName: header,
     field: header,
     sortable: true,
     filter: true,
     resizable: true
   }));
   // Parse each subsequent line to object
   const parsedCsv = lines.slice(1).map(line => {
    const values = this.parseCsvLine(line);
    const obj: any = {};
    headers.forEach((header, i) => {
      const key = header.trim().replace(/^"+|"+$/g, ''); // remove quotes from header
      let rawValue = (values[i] || '').trim();

      // Clean the value: remove outer quotes and replace double double-quotes with single quotes
      if (rawValue.startsWith('"') && rawValue.endsWith('"')) {
        rawValue = rawValue.slice(1, -1).replace(/""/g, '"'); // Unescape
      }

      try {
        if ((rawValue.startsWith('{') || rawValue.startsWith('[')) &&
            (rawValue.endsWith('}') || rawValue.endsWith(']'))) {
          obj[key] = JSON.parse(rawValue);
        } else {
          obj[key] = rawValue;
        }
      } catch (e) {
        obj[key] = rawValue;
      }
      
    });
    return obj;
  });
  
   this.uploadData = {
    csvContent: parsedCsv,
    fileName: file.name,
    duplicates: false,
    attributes:true
  };
  console.log(this.uploadData)
  // this.rowData = parsedCsv;
  this.uploadFile = false;
  this.initializeGridFromUploadedFile(this.uploadData)
  // this.sendExcelData();

  input.value = ''; // Reset input
  
  }
  reader.readAsText(file);
}

 parseCsvLine(line: string): string[] {
  const result: string[] = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    const nextChar = line[i + 1];

    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        current += '"'; // Escaped quote
        i++; // Skip next quote
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === ',' && !inQuotes) {
      result.push(current);
      current = '';
    } else {
      current += char;
    }
  }

  result.push(current);
  return result.map(cell => cell.trim());
}

splitCSVRows(csv: string): string[] {
  const rows: string[] = [];
  let currentRow = '';
  let inQuotes = false;

  for (let i = 0; i < csv.length; i++) {
    const char = csv[i];
    const nextChar = csv[i + 1];

    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        currentRow += '"'; // Escaped quote
        i++;
      } else {
        inQuotes = !inQuotes;
        currentRow += char;
      }
    } else if ((char === '\n' || (char === '\r' && nextChar === '\n')) && !inQuotes) {
      rows.push(currentRow);
      currentRow = '';
      if (char === '\r') i++; // skip \n after \r
    } else {
      currentRow += char;
    }
  }

  if (currentRow.trim()) rows.push(currentRow);
  return rows;
}


    /**
	 * @Author: Venkata Shyam
	 * @Date:18-06-2025
	 * @apiNote : This method will take all the information of excel parser for insertion operation
	 */ 
sendExcelData(validData:any[]){
  
 if(this.data.edata === 'mappingattributes'){
  console.log('Excel Data for Save', validData);
  const invalidMappings = validData
  .filter(item => item.mappingObjectId === undefined || item.mappingObjectId === null)
  .map(item => ({
    ...item,
    remarks: 'Object mapping is failed please check the objects configuared for both source and target'
  }));
  validData = validData.filter(item =>
    item.mappingObjectId !== undefined && item.mappingObjectId !== null
  );
  console.log('Valid Data after removing invalid mapping:', validData);
   //  Empty source or target attributes
 const emptyAttributeMappings = validData.filter(item => {
  const mappingType = (item.mapping_type || '').toLowerCase();
  const isAllowedEmptyTarget = mappingType === 'no mapping';
  const isAllowedEmptySource = mappingType === 'direct mapping' || mappingType === 'functional mapping';

  const isSourceEmpty = !isAllowedEmptySource && (!item.source_attribute || item.source_attribute.length === 0);
  const isTargetEmpty = !isAllowedEmptyTarget && (!item.target_attribute_list || item.target_attribute_list.length === 0);
  const isTargetRawString = !isAllowedEmptyTarget && typeof item.target_attribute === 'string' && item.target_attribute.trim().length > 0 && !Array.isArray(item.target_attribute_list);

  return isSourceEmpty || isTargetEmpty || isTargetRawString;
}).map(item => ({
  ...item,
  remarks: 'Missing attributes: Source or Target attribute list is empty or invalid'
}));

  console.log("Invalid Mappings (no mappingObjectId):", invalidMappings);
  console.log('Empty Attribute Mappings:', emptyAttributeMappings);
// Final filter for truly valid data
validData = validData.filter(item => {
  const mappingType = (item.mapping_type || '').toLowerCase();
  const isAllowedEmptyTarget = mappingType === 'no mapping';
  const isAllowedEmptySource = mappingType === 'direct mapping' || mappingType === 'functional mapping';

  return (
    item.mappingObjectId !== undefined && 
    item.mappingObjectId !== null && 
    (isAllowedEmptySource || (item.source_attribute && item.source_attribute.length > 0)) && 
    (isAllowedEmptyTarget || (item.target_attribute_list && item.target_attribute_list.length > 0))
  );
});



  console.log('Cleaned Valid Data:', validData);
  if (validData.length === 0) {
    const totalInvalid = invalidMappings.length;
    const totalEmptyAttr = emptyAttributeMappings.length;
  
    let reasonMsg = '';
    if (totalInvalid > 0 && totalEmptyAttr > 0) {
      reasonMsg = `All ${totalInvalid + totalEmptyAttr} records failed due to object mapping and empty attributes.`;
    } else if (totalInvalid > 0) {
      reasonMsg = `All ${totalInvalid} records failed due to missing object mapping.`;
    } else if (totalEmptyAttr > 0) {
      reasonMsg = `All ${totalEmptyAttr} records failed due to empty source/target attributes.`;
    } else {
      reasonMsg = `No valid records to process.`;
    }
    this.snackbar.open(reasonMsg, "OK", { duration: 6000 });
    return
  }

    this.spinner.start();

  this.vaultObjectRelationshipService.uploadFileForAttributesMapping(validData).subscribe(res=>{
    if(res.error){
      this.spinner.stop();
      this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
      // input.value = ''
    }else{
      console.log(res);
      if (res?.message?.statusMessage) {
        const finalGridData= [...invalidMappings, ...emptyAttributeMappings];
        if(finalGridData.length > 0){
          this.gridAPI.setGridOption('rowData', finalGridData)
        }
        this.snackbar.open(res.message.statusMessage, "OK", { duration: 5000 });
      }
      // this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
      this.spinner.stop();
       const failedlist = res?.failedlist || []
      this.rowData = [];
      if (Array.isArray(res.duplicates) && res.duplicates.length > 0 ||invalidMappings.length >0 || emptyAttributeMappings.length >0 || failedlist.length >0 ) {
        this.rowData = res.duplicates;
        const duplicates = res.duplicates || [];
       
        // Optional: add remarks to duplicates too
        const duplicatesWithRemarks = duplicates.map(item => ({
          ...item,
          remarks: 'Duplicate entry'
        }));
  
        // Step 5: Merge invalid and duplicate rows
        const finalGridData = [...invalidMappings, ...emptyAttributeMappings, ...duplicatesWithRemarks, ...failedlist];
  
        // Step 6: Show in grid
        // this.gridAPI.setGridOption('rowData', finalGridData);
      this.duplicates = true;
      this.snackbar.open("Duplicates/Misconfiguration found and shown in grid and "+res.message.statusMessage, "OK", { duration: 5000 });
        if (finalGridData.length > 0) {
           this.gridAPI.setGridOption('rowData', finalGridData);
           this.rowData = finalGridData;
        }
      }else{
        this.rowData = [{}];
        this.gridAPI.setGridOption('rowData', []);  
        this.duplicates = false;
      }
      // input.value = ''
    }
   })
 }else if(this.data.edata === 'objectmetadata'){
  const dnsname = this.data?.dnsname
  this.tableName = this.data?.edata
  this.spinner.start()
  this.vaultObjectRelationshipService.uploadFileForObjectmetadata(this.tableName,dnsname,this.rowData).subscribe(res=>{
    if(res.error){
      this.spinner.stop();
      this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
      // input.value = ''
    }else{
      console.log(res);
      if (res?.message?.statusMessage) {
        this.snackbar.open(res.message.statusMessage, "OK", { duration: 5000 });
      }
      // this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
      this.spinner.stop();
      this.rowData = [];
      if (Array.isArray(res.duplicates) && res.duplicates.length > 0) {
        this.rowData = res.duplicates;
        this.gridAPI.setGridOption('rowData', res.duplicates);
      this.duplicates = true;
      this.snackbar.open("Duplicates found and shown in grid and "+res.message.statusMessage, "OK", { duration: 5000 });
        
      }else{
        this.rowData = [{}];
        this.gridAPI.setGridOption('rowData', []);  
        this.duplicates = false;
      }
      // input.value = ''
    }
   })
 }else if(this.data.edata === 'stageobjects'){
    const dnsname = this.data?.dnsname
    console.log("TenantId",dnsname)
    console.log(validData)
    console.log(validData);
      this.spinner.start()
     this.vaultObjectRelationshipService.uploadFileForStageObjects(validData,dnsname).subscribe(res=>{
    if(res.error){
      this.spinner.stop();
      this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
      // input.value = ''
    }else{
      console.log(res);
        const arr = Array.isArray(res) ? res : [res];
        const filteredArr = arr.filter(stage => stage.remarks?.statusMessage !== "Successfully Record is Inserted");
        const filteredArrForUpdates =filteredArr.filter(stage => stage.remarks?.statusMessage !=="Record updated successfully")
        const backendRowData = filteredArrForUpdates.map(stage => ({
  objectGroupName:stage.objectGroupName,
  datasetname: stage.datasetname,
  description: stage.description,
  columns: stage.columns.map(c => c.alias).join(", "),
  sorting: stage.sorting.map(s => `${s.orderKeyAlias} ${s.orderAllign}`).join(", "),
  columnfilter: stage.columnFiltersExpression || "",
  transformationQuery: stage.transformationQuery,
   remarks: stage.remarks?.statusMessage !== "Successfully Record is Inserted"
            ? stage.remarks?.statusMessage
            : ""   // hide success remarks
}));


          const rowData = [...backendRowData,...this.invalidRowdataOfStage]

//         const rowData = arr.map(stage => ({
//   datasetname: stage.datasetname,
//   description: stage.description,
//   columns: stage.columns.map(c => c.alias).join(", "),   // ✅ flatten aliases
//   sorting: stage.sorting.map(s => `${s.orderKeyAlias} ${s.orderAllign}`).join(", "),
//   columnfilter: stage.columnFiltersExpression || "",
//   transformationQuery: stage.transformationQuery,
//   remarks: stage.remarks?.statusMessage
// }));

       const failedRemarks = arr.filter(item => item.remarks?.statusMessage !== "Successfully Record is Inserted")
    .map(item => item.remarks);

  console.log("Remarks other than success:", failedRemarks)
      const success = arr.filter(item => item.remarks?.statusMessage === "Successfully Record is Inserted");
      const updates = arr.filter(item => item.remarks?.statusMessage === "Record updated successfully");
      const duplicates = arr.filter(item => item.remarks?.statusMessage?.toLowerCase().includes("duplicate"));
      const failures = arr.filter(item => item.remarks?.error === true);
      this.failedRecords = failures;
  //   let message = "";
  //   if (this.invalidRowdataOfStage.length > 0) {
  //   message = "File uploaded but some rows were invalid and not inserted";
  //   } else if (failures.length === 0 && success.length === arr.length) {
  //     //  All good
  //     message = "File uploaded successfully";
  //   } else if (failures.some(f => f.remarks?.statusMessage?.toLowerCase().includes("duplicate"))) {
  //     //  Duplicates found
  //     message = "File uploaded successfully but contains duplicates";
  //   } else if (failures.length > 0) {
  //   message = "File uploaded but some rows failed";
  // }
   let parts: string[] = [];
    if (success.length > 0) parts.push(`${success.length} record(s) inserted`);
    if (updates.length > 0) parts.push(`${updates.length} record(s) updated`);
    if (duplicates.length > 0) parts.push(`${duplicates.length} duplicate(s) found`);
    if (failures.length > 0) parts.push(`${failures.length} record(s) failed`);
    if (this.invalidRowdataOfStage.length > 0) parts.push(`${this.invalidRowdataOfStage.length} invalid row(s) not inserted`);
    if (parts.length === 0) parts.push("no changes detected");

    const message = "File upload status: " + parts.join(", ");
    this.setStageResponseintogrid()
        if (this.gridAPI) {
      this.gridAPI.setGridOption('columnDefs', this.columnDefs);
      this.gridAPI.setGridOption('rowData', rowData); // also set row data
    }

       this.spinner.stop();
       this.snackbar.open(message, "OK", { duration: 5000 });
     this.duplicates = true;

    }
   })
 }
 else{
  const dnsname = this.data?.dnsname
  this.tableName = this.data?.edata
  this.spinner.start()
  this.vaultObjectRelationshipService.uploadFileForVaultObjectRelationship(this.tableName,dnsname,this.rowData).subscribe(res=>{
      if(res.error){
        this.spinner.stop();
        this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        // input.value = ''
      }else{
        console.log(res);
        let failedRecords: any[] = [];
        if(this.tableName === 'sqlscripts__j'){
             try {
		      const raw = res.data;
  // Split by "}, {" boundaries (between records)
		      const recordStrings = raw
		      .replace(/^\[|\]$/g, '') // remove [ and ]
		      .split('}, {')
		      .map(r => r.replace(/^{|}$/g, '').trim());

  // Parse each record manually
		    failedRecords = recordStrings.map(recStr => {
		    const recordObj: any = {};
    // Match key=value pairs
		    const matches = recStr.matchAll(/(\w+)=([^,{}]+)/g);
		    for (const m of matches) {
			    recordObj[m[1].trim()] = m[2].trim();
		    }
		  return recordObj;
	    });

	  } catch (err) {
		  console.error("Failed to parse failedRecords:", err);
		  console.log("Raw data:", res.data);
	  }

        console.log(failedRecords)
        if (failedRecords && failedRecords.length > 0) {
      console.log("Failed Records → Updating Grid", failedRecords);
      this.setSqlScriptsColumns();
      if(this.gridAPI){
        this.gridAPI.setGridOption('rowData', []);  
        console.log("Inside grid for response from sqlscripts")
      this.gridAPI.setGridOption('columnDefs', this.columnDefs);
      this.gridAPI.setGridOption('rowData', failedRecords);
      this.duplicates = true;
      }
    } else {
      console.log("No failed records → Grid not updated");
      this.dialogref.close();
    }
        }else{
          this.dialogref.close();
        }
        this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        this.spinner.stop();
     
        // this.dialogref.close();
        // input.value = ''
        // this.selectDns(this.name)
      }
     })

 }
  
 }

parseBoolean:any
parseBooleanForYesOrNo:any
initializeGridFromUploadedFile(data: any): void {
  console.log(this.data.edata)
  console.log(data.attributes)
  console.log(data)
  this.spinner.start();
  const safeJsonParse = (val: string) => {
    if (!val) return val;
    try {
      return JSON.parse(val);
    } catch (e) {
      console.warn("Invalid JSON, returning as string:", val);
      return val;
    }
  };

  let incomingData = [];
  if (data && data.csvContent) {
    this. parseBoolean = (val: any): string | '' => {
  const raw = (val || '').toString().trim().toLowerCase();
  if (['true', 'yes'].includes(raw)) return 'true';
  if (['false', 'no'].includes(raw)) return 'false';
  return '';
};

  this.parseBooleanForYesOrNo = (val:any):string | '' =>{
     const raw = (val || '').toString().trim().toLowerCase();
  if (['true', 'yes'].includes(raw)) return 'Yes';
  if (['false', 'no'].includes(raw)) return 'No';
  return '';
  }

    //  From file upload
    incomingData = data.csvContent;
    this.duplicates = data.duplicates ?? false;
    if (this.duplicates === true) {
      this.snackbar.open(
        data.message?.statusMessage + " and duplicates are displayed in the grid which are not modified",
        "OK",
        { duration: 5000 }
      );
    }
  } else if (Array.isArray(data)) {
    // From API, if needed
    incomingData = data;
  } else {
    console.warn("No valid data found to display in popup.");
    this.rowData = [];
    return;
  }
  if(this.data.edata ==='mappingattributes'){
    this.showbutton = false
  }else{
    this.showbutton = true
  }

  if (this.data.edata == 'mappingattributes') {
    
    this.rowData = incomingData.map(item => ({
      source_object: item["Source Object"] || item.source_object,
      target_object: item["Target Object"] || item.target_object,
      source_attribute: JSON.stringify(item["Source Attributes"] || item.source_attribute),
      target_attribute: item["Target Attribute"] || item.target_attribute,
      mapping_type: (() => {
      const raw = item["Mapping Type"] || item.mapping_type;
      if (!raw) return '';
      const found = this.mappingTypeDataDropDown.find(mt =>
      mt.lookupvalue?.toLowerCase() === raw.trim().toLowerCase()
       );
       return found?.lookupvalue ?? raw.trim();
      })(),

      codelistname: item["Codelist Name"] || item.codelistname,
      mapping_logic: item["Transformation Expressions"] || item.mapping_logic,
      exceptionquery: item["Exception Expressions"] || item.exceptionquery,
      bussinesslogic: item["Bussiness Logic"] || item.bussinesslogic,

      codelist_value_type: (() => {
       const raw = item["Codelist Value Type"] || item.codelist_value_type;
       if (!raw) return '';
       const found = this.default.find(mt =>
        mt.lookupvalue?.toLowerCase() === raw.trim().toLowerCase()
       );
      return found?.lookupvalue ?? raw.trim();
      })(),

      selected_object:item["Selected Object"] || item.selected_object,
     selected_attributes: item["Selected Attribute"] || item["Selected Attributes"] || item.selected_attributes,
      query:item["Query"] || item.query,
      reference_source:item["Reference Source Objects"] || item.reference_source,
      reference_target:item["Reference Target Objects"] || item.reference_target,
      reference_library:(() =>{
        const raw = item["Reference Value Mapping"] || item.reference_library;
        if (!raw) return '';
        const found = this.codeListData.find(item => item.mappingTypeName?.toLocaleLowerCase() === raw.trim().toLowerCase());
        return found?.mappingTypeName ?? raw.trim();
      })(),
      reference_vault_object:item["Reference Library Objects"] || item.reference_vault_object,
      reference_global_object:item["Reference Global Objects"] || item.reference_global_object,
      reference_global_source_library:item["Reference Global Source Objects"] || item.reference_global_source_library,
      global_external_object:item["Global External Objects"] || item.global_external_object,
       reference_Database_Object_Name:item["Reference DB Object Name"] || item.reference_Database_Object_Name,
      reference_Database_Object_Fetch_Partial:item["Reference DB Object Fetch Partials"] || item.reference_Database_Object_Fetch_Partial,
      status: item["Status"] || item.status,
      createdBy: item["Created By"] || item.createdBy,
      createdDate: item["Created Date"] || item.createdDate,
      lastModifiedBy: item["Last Modified By"] || item.lastModifiedBy,
      lastModifiedDate: item["Last Modified Date"] || item.lastModifiedDate,
      
    }));
  } else if(this.data.edata ==='objectmetadata') {
    this.rowData = incomingData.map(item => ({
      objectlabel: item["Object Label"] || item.objectlabel,
      objectname: item["Object Name"] || item.objectname,
      objecttype: item["Object Type"] || item.objecttype,
      attributes: item["Attributes"] || item.attributes,
      parentobject: item["Parent Object"] || item.parentobjectname,
      primarykey: item["Primary Key"] || item.primarykey,
      referencingkey: item["Referencing Key"] || item.referencingkey,
      referencedkey: item["Referenced Key"] || item.referencedkey,
      triggeredallowed: item["Trigger Allowed"] || item.triggeredallowed,
      isParentorchild:item["Is Parent(Yes or No)"] || item.isParentorchild,
      statusCol: item["Status Col"] || item["statusCol"],
      source: item["Source"] || item.source
    }));
  }
  else if(this.data.edata ==='vaultobjectrelationship'){
     this.rowData = incomingData.map(item => ({
      id:item["Id"] || item.id,
      objectname: item["Object Name"] || item.objectname,
      parentobjectname: item["Parent Object Name"] || item.parentobjectname,
      uniquekeycolumn: item["Unique Key Column"] || item.uniquekeycolumn,
      columnsfromparentfile: item["Columns From Parent File"] || item.columnsfromparentfile,
      parentrefcolumn: item["Parent Ref Column"] || item.parentrefcolumn,
      parentfilename: item["Parent File Name"] || item.parentfilename,
      childfilename: item["Child File Name"] || item.childfilename,
      uniquekeycolumnd2dvalidation: item["Uniquekey Column D2D Validation"] || item.uniquekeycolumnd2dvalidation,
      refcolmapping: item["Reference Column Mapping"] || item.refcolmapping,
      primarycolumn:item["Primary Column"] || item.primarycolumn
    }));

  }else if(this.data.edata === 'loadobjectsmstr'){

   

    this.rowData = incomingData.map(item => {

      const fileName = (item["File Name"] ?? item.fileName ?? '').trim();
      const selfObj =
        item["Self Reference Object"] || item.selfreferenceobject;

    const selfFields =
      item["Self Reference Fields"] || item.selfreferencefields;

    const circularObj =
      item["Circular Reference Object"] || item.circularreferenceobject;

    const circularFields =
      item["Circular Reference Fields"] || item.circularreferencefields;

    return {

      loadobjectsmstrid:item["Load Object Id"] || item.loadobjectsmstrid,
      objectname: item["Object Name"] || item.objectname,
      loadorder: item["Load Order"] || item.loadorder,
     isloadable: item["Is Loadable"] || item.isloadable, // raw string value
      isParent: item["Is Parent"] || item.isParent,
	    level: item["Object Level"] || item.level,
     deferred: item["Deferred"] || item.deferred,
    vaultextraction:item["Vault Extraction"] || item.vaultextraction,
    vqlcriteria: item["Vql Criteria"] || item.vqlcriteria,
     requiresglobalobject:item["Global Object"] || item.requiresglobalobject,
	  type:item["Type"] || item.type,
	  objecttype:item["Object Type"] || item.objecttype,
      fileName,
	  deletionLevel:item["Deletion Level"] || item.deletionLevel,
	  loadaction:item["Load Action"] || item.loadaction,
    parentobjectnameforextraction:item["Parent Object Name For Extraction"] || item.parentobjectnameforextraction,
	  sourcedataextractionvql:item["Source Data Extraction VQL"] || item.sourcedataextractionvql,
	  objectgroupname:item["Object Group Name"] || item.objectgroupname,
    migrationmode:item["Migration Mode"]||item.migrationmode,
    selfreferenceobject: selfObj,
      selfreferencefields: selfObj && selfFields
        ? this.buildReferenceFieldsJson(selfObj, selfFields)
        : '',

      circularreferenceobject: circularObj,
      circularreferencefields: circularObj && circularFields
        ? this.buildReferenceFieldsJson(circularObj, circularFields)
        : ''
        };
    });

  }
  else if(this.data.edata === 'sqlscripts__j'){
    this.rowData = incomingData.map(item => ({
      sqlscriptid__j:item["Id"] || item.sqlscriptid__j,
      sqlscript__j: item["SQL Query"] || item.sqlscript__j,
      formated_sqlscript__j: item["Pre Defined sqlscript Query"] || item.formated_sqlscript__j,
      automatically_formate: item["Format Date"] || item.automatically_formate,
      filename__j: item["File Name"] || item.filename__j,
      executionorder__j: item["Execution Order"] || item.executionorder__j,
	    objectgroupname: item["Group Name"] || item.objectgroupname,
      objectname:item["Object Name"] || item.objectname,
      attachmentquery__j: item["Attachment Query"] || item.attachmentquery__j,
      extractiontype__j: item["Extraction Type(CsvExtraction/AttachmentExtraction/AuditTrailExtraction/GlobalExtraction)"] || item.extractiontype__j,
      isExecutable__j:item["Is Executable"] || item.isloadable,
      queryexecutiontype__j: item["Query Execution Type"] || item.queryexecutiontype__j,
      sourcetype__j: item["Data Source Type"] || item.sourcetype__j,
    setssplitrequired: item["Set Split Required"] || item.setssplitrequired,
	  groupextractiontype:item["Group Extraction Type(Full Data/Partial Data)"] || item.groupextractiontype,
	  sourceconnectionstring__j:item["Source Connection String"] || item.sourceconnectionstring__j,
    objectgroupid:null
    }));
  }else if(this.data.edata === 'stageobjects') {
    console.log(incomingData);
    
     this.rowData = incomingData.map(item => ({
      datasetname: item["Stage Object Label"] || item.datasetname,
      description: item["Stage Object Name"] || item.description,
     flatteningOption: (() => {
      const userValue = item["Flattening option"] || item.flatteningOption;
      if (!userValue) return '';
      if (userValue.trim().toLowerCase() === 'none') return '';
      const matched = this.flatteningOptionList.find(
    option => option.toLowerCase() === userValue?.toLowerCase()
  );

        return matched || userValue;
      })(),
      orderId:item["Order Id"] || item.orderId,
      objects: item["Object Name"] || item.objects,
      objectlabelname:item["Object Label"] || item.objectlabelname,
      attributes: item["Attributes"] || item.attributes,
      // selectedattributes: item["Selected Attributes"] || item.selectedattributes,
      // bussinesslogic: item["Bussiness Logic"] || item.bussinesslogic,
      transformationQuery:item["Expression Query"] || item.transformationQuery,
     columnfilter: item["Column Filters"] || item.columnfilter ,
      sorting:item["Sorting"] || item.sorting,
      remarks:item["Remarks"] || item.remarks,
      reference_source:item["Reference Source Objects"] || item.reference_source,
      reference_target:item["Reference Transform Objects"] || item.reference_target,
       reference_library: (() => {
      const raw = item["Reference Value Mapping"] || item.reference_library;
      if (!raw) return raw;
      const refValues = raw.split(',').map(v => v.trim());
      return refValues.map(val => {
        const match = this.codeListData.find(
          obj => obj.mappingTypeName?.toLowerCase() === val.toLowerCase()
        );
        return match ? match.mappingTypeName : val;
      }).join(',');
    })(),
      global_external_object:item["Global External Objects"] || item.global_external_object,
      reference_vault_object:item["Reference Library Objects"] || item.reference_vault_object,
      reference_global_object:item["Reference Global Objects"] || item.reference_global_object,
      reference_global_source_library:item["Reference Global Source Objects"] || item.reference_global_source_library,
      objectGroupName:item["Object Group Name"] || item.objectGroupName,
      reference_Database_Object_Name:item["Reference DB Object Name"] || item.reference_Database_Object_Name,
      reference_Database_Object_Fetch_Partial:item["Reference DB Object Fetch Partials"] || item.reference_Database_Object_Fetch_Partial,
    
  }))

  }

  console.log("Parsed rowData:", this.rowData);

  if (this.data.edata === 'mappingattributes') {
    // this.retrieveSourceAndTargetInfo();
    this.tryCompareObjects();
    this.setSourceTargetColumns();
  } else if(this.data.edata === 'objectmetadata') {
    this.setObjectColumns();
    
  }else if(this.data.edata === 'vaultobjectrelationship'){
    this.setObjectRelationshipColumns();
  }else if(this.data.edata === 'loadobjectsmstr'){
    this.setLoadobjectMstrColumns()
  }else if(this.data.edata === 'sqlscripts__j'){
    this.setSqlScriptsColumns();
  }else if(this.data.edata === 'stageobjects'){
    console.log("This is rowdata", this.rowData)
    this.mapStageJson(this.rowData);
    this.setSatgeObjectsColumn();
  }

  this.setCommonGridSettings();
  this.isGridVisible = true;
  // this.spinner.stop();
}

setSourceTargetColumns(): void { 
    this.columnDefs = [
      { headerName: 'Source Object', headerTooltip: 'Source Object', tooltipValueGetter: (params) => 'Source Object : ' + params.value, field: 'source_object', filter: 'agTextColumnFilter', width: 250 },
    { headerName: 'Target Object', headerTooltip: 'Target Object', tooltipValueGetter: (params) => 'Target Object : ' + params.value, field: 'target_object', filter: 'agTextColumnFilter', width: 250 },
    {
      headerName: 'Source Attributes',
      field: 'source_attribute',
      tooltipValueGetter: (params) => 'Source Attributes : ' + params.value,
      valueGetter: (params: any) => {
        const attrStr = params.data?.source_attribute;
    
        if (!attrStr) return '';
    
        try {
          // const attrs = JSON.parse(attrStr);
          // if (!Array.isArray(attrs)) return '';
    
          // // Return only the `name` fields joined by comma
          // return attrs.map(attr => attr.name).join(', ');
          if (Array.isArray(attrStr)) {
            // Already parsed array (from backend)
            return attrStr.map(a => a.label).join(', ');
          }
      
          const values = attrStr.replace(/^"+|"+$/g, '').trim();
          return values.replace(/\\"/g, '"');
    
        } catch (e) {
          console.error('Error parsing source_attribute:', e);
          return '';
        }
      },
      autoHeight: true,
      wrapText: true,
    },
    
    { headerName: 'Target Attribute', headerTooltip: 'Target Attribute', tooltipValueGetter: (params) => 'Target Attribute : ' + params.value, field: 'target_attribute', filter: 'agTextColumnFilter', width: 250 },
    { headerName: 'Mapping Type', headerTooltip: 'Mapping Type', tooltipValueGetter: (params) => 'Mapping Type : ' + params.value, field: 'mapping_type', filter: 'agTextColumnFilter', width: 250 },
    { headerName: 'Codelist Name', headerTooltip: 'Codelist Name', tooltipValueGetter: (params) => 'Codelist Name : ' + params.value, field: 'codelistname', filter: 'agTextColumnFilter', width: 250 },
    { headerName: 'Codelist Value Type', headerTooltip: 'Codelist Value Type', tooltipValueGetter: (params) => 'Codelist Value Type : ' + params.value, field: 'codelist_value_type', filter: 'agTextColumnFilter', width: 250 },
    { headerName: 'Transformation Expressions', headerTooltip: 'Transformation Expressions', tooltipValueGetter: (params) => 'Transformation Expressions : ' + params.value, field: 'mapping_logic', filter: 'agTextColumnFilter', width: 250 },
    { headerName: 'Exception Expressions', headerTooltip: 'Exception Expressions', tooltipValueGetter: (params) => 'Exception Expressions : ' + params.value, field: 'exceptionquery', filter: 'agTextColumnFilter', width: 250 },
    { headerName: 'Bussiness Logic', headerTooltip: 'Bussiness Logic', tooltipValueGetter: (params) => 'Bussiness Logic : ' + params.value, field: 'bussinesslogic', filter: 'agTextColumnFilter', width: 250 },
     { headerName: 'Selected Object', field: 'selected_object', tooltipValueGetter: (params) => 'Selected Object : ' + params.value, filter: 'agTextColumnFilter', width: 250 },
   {
  headerName: 'Selected Attributes',
  field: 'selected_attributes',
  tooltipValueGetter: (params) => 'Selected Attributes : ' + params.value,
  valueGetter: (params: any) => {
    const attrStr = params.data?.selected_attributes;

    if (!attrStr) return '';
    try {
      // Case 1: It's already an array of objects
      if (Array.isArray(attrStr)) {
        return attrStr.map(a => a.label || a.name || a).join(', ');
      }

      // Case 2: It's a JSON String
      if (typeof attrStr === 'string') {
        // Try to parse JSON
        try {
          const parsed = JSON.parse(attrStr);
          if (Array.isArray(parsed)) {
            return parsed.map(a => a.label || a.name || a).join(', ');
          }
        } catch {
          // Not JSON, just a plain comma separated value
        }
        return attrStr.replace(/^"+|"+$/g, '').trim();
      }

      // Fallback
      return attrStr;

    } catch (e) {
      console.error('Error parsing selected_attributes:', e);
      return '';
    }
  },
  autoHeight: true,
  wrapText: true,
},

    { headerName: 'Query', field: 'query', tooltipValueGetter: (params) => 'Query : ' + params.value, filter: 'agTextColumnFilter', width: 250 },
    { headerName: 'Remarks', headerTooltip: 'Remarks', tooltipValueGetter: (params) => 'Remarks : ' + params.value, field: 'remarks', filter: 'agTextColumnFilter', width: 250 },

    { headerName: 'Reference Source Objects', headerTooltip: 'Reference Source Objects', tooltipValueGetter: (params) => 'Reference Source Objects : ' + params.value, field: 'reference_source', filter: 'agTextColumnFilter', width: 250 },
    { headerName: 'Reference Target Objects', headerTooltip: 'Reference Target Objects', tooltipValueGetter: (params) => 'Reference Target Objects : ' + params.value, field: 'reference_target', filter: 'agTextColumnFilter', width: 250 },
    { headerName: 'Reference Library', headerTooltip: 'Reference Library', tooltipValueGetter: (params) => 'Reference Library : ' + params.value, field: 'reference_vault_object', filter: 'agTextColumnFilter', width: 250 },
     { headerName: 'Reference Value Mapping', headerTooltip: 'Reference Value Mapping', tooltipValueGetter: (params) => 'Reference Value Mapping : ' + params.value, field: 'reference_library', filter: 'agTextColumnFilter', width: 250 },
     { headerName: 'Reference Global Objects', headerTooltip: 'Reference Global Objects', tooltipValueGetter: (params) => 'Reference Global Objects : ' + params.value, field: 'reference_global_object', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Reference Global Source Objects', headerTooltip: 'Reference Global Source Objects', tooltipValueGetter: (params) => 'Reference Global Source Objects : ' + params.value, field: 'reference_global_source_library', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Global External Objects', headerTooltip: 'Global External Objects', tooltipValueGetter: (params) => 'Global External Objects : ' + params.value, field: 'global_external_object', filter: 'agTextColumnFilter', width: 250 },
       { headerName: 'Reference DB Object Name',headerTooltip:'Reference DB Object Name',tooltipValueGetter: (params) => 'Reference DB Object Name : ' + params.value, field: 'reference_Database_Object_Name', width: 400 },
     { headerName: 'Reference DB Object Fetch Partials',headerTooltip:'Reference DB Object Fetch Partials',tooltipValueGetter: (params) => 'Reference DB Object Fetch Partials : ' + params.value, field: 'reference_Database_Object_Fetch_Partial', width: 400 },
   
    
    ];
}
setObjectColumns(): void {
  this.columnDefs = [
    {
      headerName: 'Object Label',
      headerTooltip: 'Object Label',
      tooltipValueGetter: (params) => 'Object Label : ' + params.value,
      field: 'objectlabel',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Object Name',
      headerTooltip: 'Object Name',
      tooltipValueGetter: (params) => 'Object Name : ' + params.value,
      field: 'objectname',
      filter: 'agTextColumnFilter',
      width: 180
    },
    {
     headerName: 'Object Type',
     headerTooltip: 'Object Type',
     tooltipValueGetter: (params) => 'Object Type : ' + params.value,
     field: 'objecttype',
     filter: 'agTextColumnFilter',
     width: 180
   },
   {
     headerName: 'Attributes',
     headerTooltip: 'Attributes',
     field: 'attributes',
     filter: 'agTextColumnFilter',
     width: 300,
     tooltipValueGetter: (params) => {
       return 'Attributes: ' + JSON.stringify(params.value, null, 2);
     },
     valueFormatter: (params) => {
       if (params.value) {
         // stringify with minimal formatting, to show [{...}, {...}] style
         return JSON.stringify(params.value);
       }
       return '';
     }
   }
   ,
    {
      headerName: 'Parent Object',
      headerTooltip: 'Parent Object',
      tooltipValueGetter: (params) => 'Parent Object : ' + params.value,
      field: 'parentobjectname',
      filter: 'agTextColumnFilter',
      width: 200
    },
    {
      headerName: 'Primary Key',
      headerTooltip: 'Primary Key',
      tooltipValueGetter: (params) => 'Primary Key : ' + params.value,
      field: 'primarykey',
      filter: 'agTextColumnFilter',
      width: 200
    },
    {
     headerName: 'Referencing Key',
     headerTooltip: 'Referencing Key',
     tooltipValueGetter: (params) => 'Referencing Key : ' + params.value,
     field: 'referencingkey',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Referenced Key',
     headerTooltip: 'Referenced Key',
     tooltipValueGetter: (params) => 'Referenced Key : ' + params.value,
     field: 'referencedkey',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Trigger Allowed',
     headerTooltip: 'Trigger Allowed',
     tooltipValueGetter: (params) => 'Trigger Allowed : ' + params.value,
     field: 'triggeredallowed',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Is Parent Or Child(Yes/No)',
     headerTooltip: 'Is Parent Or Child',
     tooltipValueGetter: (params) => 'Is Parent Or Child : ' + params.value,
     field: 'isParentorchild',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Status Col',
     headerTooltip: 'Status Col',
     tooltipValueGetter: (params) => 'Status Col : ' + params.value,
     field: 'statusCol',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Source',
     headerTooltip: 'Source',
     tooltipValueGetter: (params) => 'Source : ' + params.value,
     field: 'source',
     filter: 'agTextColumnFilter',
     width: 200
   }
   
  ];
}
setCommonGridSettings(): void {
  this.rowClassRules = {
    'rowBackgroundColor': (params) => {
      const numSickDays = params.node.data.status;
      return numSickDays === "No" || numSickDays === null;
    }
  };

  this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
    sortable: true,
    resizable: true,
    filter: true
  };

  this.rowSelection = this.constants.rowselection;
  this.paginationPageSize = this.constants.pagesize;
  this.paginationNumberFormatter = (params) => params.value.toLocaleString();
  this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
  this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
}

  
setObjectRelationshipColumns(): void {
  this.columnDefs = [
    {
      headerName: 'Id',
      headerTooltip: 'Id',
      tooltipValueGetter: (params) => 'Id : ' + params.value,
      field: 'id',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Object Name',
      headerTooltip: 'Object Name',
      tooltipValueGetter: (params) => 'Object Name : ' + params.value,
      field: 'objectname',
      filter: 'agTextColumnFilter',
      width: 180
    },
    {
      headerName: 'Parent Object',
      headerTooltip: 'Parent Object',
      tooltipValueGetter: (params) => 'Parent Object : ' + params.value,
      field: 'parentobjectname',
      filter: 'agTextColumnFilter',
      width: 200
    },
    {
      headerName: 'Unique Key Column',
      headerTooltip: 'Unique Key Column',
      tooltipValueGetter: (params) => 'Unique Key Column : ' + params.value,
      field: 'uniquekeycolumn',
      filter: 'agTextColumnFilter',
      width: 200
    },
    {
     headerName: 'Columns From Parent File',
     headerTooltip: 'Columns From Parent File',
     tooltipValueGetter: (params) => 'Columns From Parent File : ' + params.value,
     field: 'columnsfromparentfile',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Parent Ref Colum',
     headerTooltip: 'Parent Ref Colum',
     tooltipValueGetter: (params) => 'Parent Ref Colum : ' + params.value,
     field: 'parentrefcolumn',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Child File Name',
     headerTooltip: 'Child File Name',
     tooltipValueGetter: (params) => 'Child File Name : ' + params.value,
     field: 'childfilename',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Parent File Name',
     headerTooltip: 'Parent File Name',
     tooltipValueGetter: (params) => 'Parent File Name : ' + params.value,
     field: 'parentfilename',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'UniqueKey Column D2D Validation',
     headerTooltip: 'UniqueKey Column D2D Validation',
     tooltipValueGetter: (params) => 'UniqueKey Column D2D Validation : ' + params.value,
     field: 'uniquekeycolumnd2dvalidation',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Reference Column Mapping',
     headerTooltip: 'Reference Column Mapping',
     tooltipValueGetter: (params) => 'Reference Column Mapping : ' + params.value,
     field: 'refcolmapping',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Primary Column',
     headerTooltip: 'Primary Column',
     tooltipValueGetter: (params) => 'Primary Column : ' + params.value,
     field: 'primarycolumn',
     filter: 'agTextColumnFilter',
     width: 200
   }
   
  ];
}


setSqlScriptsColumns():void{
  this.columnDefs = [
    {
      headerName: 'Id',
      headerTooltip: 'Id',
      tooltipValueGetter: (params) => 'Id : ' + params.value,
      field: 'sqlscriptid__j',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'SQL Query',
      headerTooltip: 'SQL Query',
      tooltipValueGetter: (params) => 'SQL Query : ' + params.value,
      field: 'sqlscript__j',
      filter: 'agTextColumnFilter',
      width: 180
    },
    {
      headerName: 'Pre Defined sqlscript Query',
      headerTooltip: 'Pre Defined sqlscript Query',
      tooltipValueGetter: (params) => 'Pre Defined sqlscript Query : ' + params.value,
      field: 'formated_sqlscript__j',
      filter: 'agTextColumnFilter',
      width: 180
    },
    {
      headerName: 'Format Date',
      headerTooltip: 'Format Date',
      tooltipValueGetter: (params) => 'Format Date : ' + params.value,
      field: 'automatically_formate',
      filter: 'agTextColumnFilter',
      width: 180
    },
    {
      headerName: 'File Name',
      headerTooltip: 'File Name',
      tooltipValueGetter: (params) => 'File Name : ' + params.value,
      field: 'filename__j',
      filter: 'agTextColumnFilter',
      width: 200
    },
    {
     headerName: 'Execution Order',
     headerTooltip: 'Execution Order',
     tooltipValueGetter: (params) => 'Execution Order : ' + params.value,
     field: 'executionorder__j',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Attachment Query',
     headerTooltip: 'Attachment Query',
     tooltipValueGetter: (params) => 'Attachment Query : ' + params.value,
     field: 'attachmentquery__j',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Extraction Type',
     headerTooltip: 'Extraction Type',
     tooltipValueGetter: (params) => 'Extraction Type : ' + params.value,
     field: 'extractiontype__j',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Is Executable',
     headerTooltip: 'Is Executable',
     tooltipValueGetter: (params) => 'Is Executable : ' + params.value,
     field: 'isExecutable__j',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Query Execution Type',
     headerTooltip: 'Query Execution Type',
     tooltipValueGetter: (params) => 'Query Execution Type : ' + params.value,
     field: 'queryexecutiontype__j',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Data Source Type',
     headerTooltip: 'Data Source Type',
     tooltipValueGetter: (params) => 'Data Source Type : ' + params.value,
     field: 'sourcetype__j',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Group Name',
     headerTooltip: 'Group Name',
     tooltipValueGetter: (params) => 'Group Name : ' + params.value,
     field: 'objectgroupname',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Object Name',
     headerTooltip: 'Object Name',
     tooltipValueGetter: (params) => 'Object Name : ' + params.value,
     field: 'objectname',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Set Split Required',
     headerTooltip: 'Set Split Required',
     tooltipValueGetter: (params) => 'Set Split Required : ' + params.value,
     field: 'setssplitrequired',
     filter: 'agTextColumnFilter',
     width: 200
   },
   {
     headerName: 'Group Extraction Type',
     headerTooltip: 'Group Extraction Type',
     tooltipValueGetter: (params) => 'Group Extraction Type : ' + params.value,
     field: 'groupextractiontype',
     filter: 'agTextColumnFilter',
     width: 200
   },
      {
  headerName: 'Remarks',
  headerTooltip: 'Remarks',
  field: 'reason',
  filter: 'agTextColumnFilter',
  width: 250,
  tooltipValueGetter: (params) => 'Remarks : ' + params.value,
  cellStyle: params => {
    if (params.value) {
      return { color: 'red', fontWeight: 'bold' }; // highlight invalid
    }
    return { color: 'green' }; // highlight valid
  }
}
   
  ];
	
}


setLoadobjectMstrColumns(): void {
  this.columnDefs = [
    {
      headerName: 'Load Object Id',
      headerTooltip: 'Load Object Id',
      tooltipValueGetter: (params) => 'Load Object Id : ' + params.value,
      field: 'loadobjectsmstrid',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Object Name',
      headerTooltip: 'Object Name',
      tooltipValueGetter: (params) => 'Object Name : ' + params.value,
      field: 'objectname',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Load Order',
      headerTooltip: 'Load Order',
      tooltipValueGetter: (params) => 'Load Order : ' + params.value,
      field: 'loadorder',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Is Loadable',
      headerTooltip: 'Is Loadable',
      tooltipValueGetter: (params) => 'Is Loadable : ' + params.value,
      field: 'isloadable',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Is Parent',
      headerTooltip: 'Is Parent',
      tooltipValueGetter: (params) => 'Is Parent : ' + params.value,
      field: 'isParent',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Object Level',
      headerTooltip: 'Object Level',
      tooltipValueGetter: (params) => 'Object Level : ' + params.value,
      field: 'level',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Deferred',
      headerTooltip: 'Deferred',
     tooltipValueGetter: (params) => 'Deferred : ' + params.value,
      
  //      valueFormatter: (params) => {
  //   return params.value === true ? 'Yes' : params.value === false ? 'No' : '';
  // },
      field: 'deferred',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Vault Extraction(Yes/No)',
      headerTooltip: 'Vault Extraction(Yes/No)',
      tooltipValueGetter: (params) => 'Vault Extraction : ' + params.value,
      field: 'vaultextraction',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Vql Criteria',
      headerTooltip: 'Vql Criteria',
      tooltipValueGetter: (params) => 'Vql Criteria : ' + params.value,
      field: 'vqlcriteria',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Global Object',
      headerTooltip: 'Global Object',
      tooltipValueGetter: (params) => 'Global Object : ' + params.value,
  //  valueFormatter: (params) => {
  //   return params.value === true ? 'Yes' : params.value === false ? 'No' : '';
  // },
      field: 'requiresglobalobject',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Parent Object Name For Extraction',
      headerTooltip: 'Parent Object Name For Extraction',
      tooltipValueGetter: (params) => 'Parent Object Name : ' + params.value,
      field: 'parentobjectnameforextraction',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Type',
      headerTooltip: 'Type',
      tooltipValueGetter: (params) => 'Type : ' + params.value,
      field: 'type',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Object Type',
      headerTooltip: 'Object Type',
      tooltipValueGetter: (params) => 'Object Type : ' + params.value,
      field: 'objecttype',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'File Name',
      headerTooltip: 'File Name',
      tooltipValueGetter: (params) => 'File Name : ' + params.value,
      field: 'fileName',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Deletion Level',
      headerTooltip: 'Deletion Level',
      tooltipValueGetter: (params) => 'Deletion Level : ' + params.value,
      field: 'deletionLevel',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Load Action',
      headerTooltip: 'Load Action',
      tooltipValueGetter: (params) => 'Load Action : ' + params.value,
      field: 'loadaction',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Object Group Name',
      headerTooltip: 'Object Group Name',
      tooltipValueGetter: (params) => 'Object Group Name : ' + params.value,
      field: 'objectgroupname',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Source Data Extraction VQL',
      headerTooltip: 'Source Data Extraction VQL',
      tooltipValueGetter: (params) => 'Source Data Extraction VQL : ' + params.value,
      field: 'sourcedataextractionvql',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Migration Mode',
      headerTooltip: 'Migration Mode',
      tooltipValueGetter: (params) => 'Migration Mode : ' + params.value,
      field: 'migrationmode',
      filter: 'agTextColumnFilter',
      width: 230
    },
     {
      headerName: 'Self Reference Object',
      headerTooltip: 'Self Reference Object',
      tooltipValueGetter: (params) => 'Self Reference Object : ' + params.value,
      field: 'selfreferenceobject',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Self Reference Fields',
      headerTooltip: 'Self Reference Fields',
      tooltipValueGetter: (params) => 'Self Reference Fields : ' + params.value,
      field: 'selfreferencefields',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Circular Reference Object',
      headerTooltip: 'Circular Reference Object',
      tooltipValueGetter: (params) => 'Circular Reference Object : ' + params.value,
      field: 'circularreferenceobject',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Circular Reference Fields',
      headerTooltip: 'Circular Reference Fields',
      tooltipValueGetter: (params) => 'Circular Reference Fields : ' + params.value,
      field: 'circularreferencefields',
      filter: 'agTextColumnFilter',
      width: 230
    }
  ];
}

setSatgeObjectsColumn(){
  this.columnDefs = [
    {
      headerName: 'Object Group Name',
      headerTooltip: 'Object Group Name',
      tooltipValueGetter: (params) => 'Object Group Name : ' + params.value,
      field: 'objectGroupName',
      filter: 'agTextColumnFilter',
      width: 230
    },
     {
      headerName: 'Stage Object Label',
      headerTooltip: 'Stage Object Label',
      tooltipValueGetter: (params) => 'Stage Object Label : ' + params.value,
      field: 'datasetname',
      filter: 'agTextColumnFilter',
      width: 230
    },
     {
      headerName: 'Stage Object Name',
      headerTooltip: 'Stage Object Name',
      tooltipValueGetter: (params) => 'Stage Object Name : ' + params.value,
      field: 'description',
      filter: 'agTextColumnFilter',
      width: 230
    },
     {
      headerName: 'Flattening option',
      headerTooltip: 'Flattening option',
      tooltipValueGetter: (params) => 'Flattening option : ' + params.value,
      field: 'flatteningOption',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Order Id',
      headerTooltip: 'Order Id',
      tooltipValueGetter: (params) => 'Order Id : ' + params.value,
      field: 'orderId',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Object Name',
      headerTooltip: 'Object Name',
      tooltipValueGetter: (params) => 'Objects : ' + params.value,
      field: 'objects',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Object Label',
      headerTooltip: 'Object label',
      tooltipValueGetter: (params) => 'Objects : ' + params.value,
      field: 'objectlabelname',
      filter: 'agTextColumnFilter',
      width: 230
    },
     {
      headerName: 'Attributes',
      headerTooltip: 'Attributes',
      tooltipValueGetter: (params) => 'Attributes : ' + params.value,
      field: 'attributes',
      filter: 'agTextColumnFilter',
      width: 230
    },
     {
      headerName: 'Expression Query',
      headerTooltip: 'Expression Query',
      tooltipValueGetter: (params) => 'Expression Query : ' + params.value,
      field: 'transformationQuery',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Column Filters',
      headerTooltip: 'Column Filters',
      tooltipValueGetter: (params) => 'Column Filters : ' + params.value,
      field: 'columnfilter',
      filter: 'agTextColumnFilter',
      width: 230
    },
    {
      headerName: 'Sorting',
      headerTooltip: 'Sorting',
      tooltipValueGetter: (params) => 'Sorting : ' + params.value,
      field: 'sorting',
      filter: 'agTextColumnFilter',
      width: 230
    },
     { headerName: 'Reference Source Objects',headerTooltip:'Reference Source Objects',tooltipValueGetter: (params) => 'Reference Source Objects : ' + params.value, field: 'reference_source', width: 400 },
  { headerName: 'Reference Transform Objects',headerTooltip:'Reference Transform Objects',tooltipValueGetter: (params) => 'Reference Transform Objects : ' + params.value, field: 'reference_target', width: 400 },
  { headerName: 'Reference Library Objects',headerTooltip:'Reference Library Objects',tooltipValueGetter: (params) => 'Reference Library Objects : ' + params.value, field: 'reference_vault_object', width: 400 },
  { headerName: 'Reference Global Objects',headerTooltip:'Reference Global Objects',tooltipValueGetter: (params) => 'Reference Global Objects : ' + params.value, field: 'reference_global_object', width: 400 },
  { headerName: 'Reference Global Source Objects',headerTooltip:'Reference Global Source Objects',tooltipValueGetter: (params) => 'Reference Global Source Objects : ' + params.value, field: 'reference_global_source_library', width: 400 },
  { headerName: 'Global External Objects',headerTooltip:'Global External Objects',tooltipValueGetter: (params) => 'Global External Objects : ' + params.value, field: 'global_external_object', width: 400 },
   { headerName: 'Reference Value Mapping',headerTooltip:'Reference Value Mapping',tooltipValueGetter: (params) => 'Reference Value Mapping : ' + params.value, field: 'reference_library', width: 400 },
    { headerName: 'Reference DB Object Name',headerTooltip:'Reference DB Object Name',tooltipValueGetter: (params) => 'Reference DB Object Name : ' + params.value, field: 'reference_Database_Object_Name', width: 400 },
     { headerName: 'Reference DB Object Fetch Partials',headerTooltip:'Reference DB Object Fetch Partials',tooltipValueGetter: (params) => 'Reference DB Object Fetch Partials : ' + params.value, field: 'reference_Database_Object_Fetch_Partial', width: 400 },
    {
  headerName: 'Remarks',
  headerTooltip: 'Remarks',
  field: 'remarks',
  filter: 'agTextColumnFilter',
  width: 250,
  cellStyle: params => {
    if (params.value) {
      return { color: 'red', fontWeight: 'bold' }; // highlight invalid
    }
    return { color: 'green' }; // highlight valid
  }
}

  ]
}

onFileChange(event: Event) {
  if (this.data.edata == 'stageobjects') {
    this.excelFileUploadWithXlsx(event);
  } else {
    this.excelFileUpload(event);
  }
}

private ensureFileNameListLoaded(): Promise<void> {
  if (this.fileNameList && this.fileNameList.length) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    this.commonService.retrieveMappingConfiguration()
      .subscribe(
        (res: any) => {

          const list = Array.isArray(res)
            ? res
            : res?.data || [];

          this.fileNameList = list.map((obj: any) => ({
            fileName: `${obj.stageobject}_${obj.targetobject}`,
            mappingconfigurationid: obj.mappingconfigurationid
          }));

          resolve();
        },
        (err: any) => {
          console.error('Failed to load mapping configuration Id', err);
          reject(err);
        }
      );
  });
}


private buildReferenceFieldsJson(
  referenceObject: string,
  referenceFields: string
): string {

  if (!referenceFields) return '';

  const fieldsArray = referenceFields
    .split(',')
    .map(f => f.trim())
    .filter(Boolean);

  const result = fieldsArray.map(value => {
    const lastDotIndex = value.lastIndexOf('.');

    if (lastDotIndex === -1) {
      return {
        filename: referenceObject,
        fields: value
      };
    }

    return {
      filename: value.substring(0, lastDotIndex),
      fields: value.substring(lastDotIndex + 1)
    };
  });

  return JSON.stringify(result);
}

private resolveMappingIdFromFileName(fileName: string) {
  if (!fileName || !this.fileNameList?.length) return null;

  const match = this.fileNameList.find(
    f => f.fileName === fileName
  );

  return match ? match.mappingconfigurationid : null;
}



 async excelFileUploadWithXlsx(event: any): Promise<void> {
  const input = event.target as HTMLInputElement;
  if (!input.files || input.files.length === 0) {
    this.snackbar.open("No Excel file is selected", "OK", { duration: 5000 });
    return;
  }

  const file = input.files[0];
  const fileName = file.name;
  const isExcel = fileName.endsWith(".xlsx") || fileName.endsWith(".xls");

  if (!isExcel) {
    this.snackbar.open("Only Excel files are allowed.", "OK", { duration: 5000 });
    input.value = '';
    return;
  }

  // const reader: FileReader = new FileReader();
  // reader.onload = (e: any) => {
  //   const binaryStr: string = e.target.result;
  //   const workbook: XLSX.WorkBook = XLSX.read(binaryStr, { type: 'binary' });

  //   // Read first sheet
  //   const sheetName: string = workbook.SheetNames[0];
  //   const sheet: XLSX.WorkSheet = workbook.Sheets[sheetName];

  //   // Convert to JSON (multi-line preserved in one cell)
  //   const parsedExcel: any[] = XLSX.utils.sheet_to_json(sheet, { defval: "", raw: false });

  //   if (parsedExcel.length === 0) {
  //     this.snackbar.open("Empty Excel file!", "OK", { duration: 5000 });
  //     input.value = '';
  //     return;
  //   }

  //   // Extract headers from first row
  //   const headers = Object.keys(parsedExcel[0]);

  //   // Validate headers against template
  //   const isValid = this.TEMPLATE_HEADERS.every(header => headers.includes(header));
  //   const noExtraColumns = headers.length === this.TEMPLATE_HEADERS.length;
  //   if (!isValid || !noExtraColumns) {
  //     this.snackbar.open("Uploaded file headers do not match the template!", "OK", { duration: 5000 });
  //     input.value = '';
  //     return;
  //   }

  //   // Assign headers to ag-grid column definitions
  //   this.columnDefs = headers.map(header => ({
  //     headerName: header,
  //     field: header,
  //     sortable: true,
  //     filter: true,
  //     resizable: true
  //   }));

  //   // Final upload data
  //   this.uploadData = {
  //     csvContent: parsedExcel,
  //     fileName: file.name,
  //     duplicates: false,
  //     attributes: true
  //   };

  //   console.log("Parsed Excel Data:", this.uploadData);

  //   this.uploadFile = false;
  //   this.initializeGridFromUploadedFile(this.uploadData);

  //   input.value = ''; // Reset input
  // };

  // reader.readAsBinaryString(file);
  try {

  const parsedExcel = await this.excelService.readExcel(file);

  if (parsedExcel.length === 0) {
    this.snackbar.open("Empty Excel file!", "OK", { duration: 5000 });
    input.value = '';
    return;
  }

  const headers = Object.keys(parsedExcel[0]);

  const isValid = this.TEMPLATE_HEADERS.every(
    header => headers.includes(header)
  );

  const noExtraColumns =
    headers.length === this.TEMPLATE_HEADERS.length;

  if (!isValid || !noExtraColumns) {
    this.snackbar.open(
      "Uploaded file headers do not match the template!",
      "OK",
      { duration: 5000 }
    );
    input.value = '';
    return;
  }

  this.columnDefs = headers.map(header => ({
    headerName: header,
    field: header,
    sortable: true,
    filter: true,
    resizable: true
  }));

  this.uploadData = {
    csvContent: parsedExcel,
    fileName: file.name,
    duplicates: false,
    attributes: true
  };

  this.uploadFile = false;

  this.initializeGridFromUploadedFile(this.uploadData);

  input.value = '';

} catch (error) {

  console.error(error);

  this.snackbar.open(
    "Unable to read Excel file",
    "OK",
    { duration: 5000 }
  );

}
}


mapStageJson(rowData: any[]): any {
  console.log("Flattening option values:", this.rowData.map(r => r.flatteningOption));
  this.uniquenessErrors = [];
  const validatedRows = this.validateRowData(rowData,this.listOfObjectsOfSource)
  console.log("Inside Json building")
  console.log(validatedRows)
  // Separate valid & invalid
  // const validRows = validatedRows.filter(r => !r.remarks || r.remarks === "");
  // const invalidRows = validatedRows.filter(r => r.remarks && r.remarks !== "");
  // this.invalidStageRows = invalidRows;
  // console.log(validRows)
  // console.log(invalidRows)
  // const stageGroup= this.groupEachSatgeAsJson(validatedRows, r =>`${r.datasetname} || ${r.description}`);
  // Filter out any group that has even one invalid row
// const validStageGroups = Object.values(stageGroup).filter(group => 
//     group.every(r => !r.remarks || r.remarks === "")
// );
// const allStageGroups = Object.values(validatedRows);
   // Build one stageJson per group
  // const stageJsons = allStageGroups.map((rows: any[],idx:number) => {

  //    const orderIds = new Set(rows.map(r => r.orderId).filter(Boolean));
  // const flatteningOptions = new Set(rows.map(r => r.flatteningOption).filter(Boolean));
  // const transformationQueries = new Set(rows.map(r => r.transformationQuery).filter(Boolean));

  // let consistencyError = "";
  // if (orderIds.size > 1) {
  //   consistencyError += `Group ${idx + 1}: Conflicting OrderIds → ${Array.from(orderIds).join(", ")}. `;
  // }
  // if (flatteningOptions.size > 1) {
  //   consistencyError += `Group ${idx + 1}: Conflicting Flattening Options → ${Array.from(flatteningOptions).join(", ")}. `;
  // }
  // if (transformationQueries.size > 1) {
  //   consistencyError += `Group ${idx + 1}: Conflicting Transformation Queries. `;
  // }
  //   //  If conflicts, push into uniquenessErrors
  // if (consistencyError) {
  //   this.uniquenessErrors.push({
  //     group: idx + 1,
  //     dataset: rows[0]?.datasetname,
  //     description: rows[0]?.description,
  //     message: consistencyError
  //   });

  //   // also append to row remarks for visibility
  //   rows = rows.map(r => ({
  //     ...r,
  //     remarks: r.remarks
  //       ? r.remarks + " | " + consistencyError
  //       : consistencyError
  //   }));
  // }
  //     //  Build selectedObjectsMap for this group
    // const selectedObjectsMap = rows.reduce((acc, row) => {
    //   if (row.objectId && row.objectlabelname) {
    //     acc[row.objectlabelname] = {
    //       id: row.objectId,
    //       details: {
    //         id: row.objectId,
    //         objectlabel: row.objectlabelname,
    //         objectname: row.objects
    //       }
    //     };
    //   }
    //   return acc;
    // }, {} as Record<string, any>);
     const stageJsons = validatedRows.map((row, idx) => {
    return {
      datasetname: row.datasetname || "",
      datasetObjectname:"",
      datasetobjectattributes:"",
      type:"",
      description: row.description || "",
      objectGroup: this.data?.dnsname,
      filters: [],
      sorting: this.mapSorting([row]),
      aggregate: [],
      columns: this.mapColumns([row]),
      concatination: [],
      rollingUp: [],
      rollupExclusionObjects: [],
      transformation: [],
      columnFilters: this.mapColumnFilters([row]),
      columnFiltersExpression: this.buildColumnFiltersExpression([row]),
      generateDefaultTemplate: true,
      autoRefreshDataset:"",
      datasetAccessType:"",
      dataset_rolesIds:"",
      createdBy:"",
      createdDateAndTime:"",
      headersType:[],
      pivotAggregation:[],
       selectedObjectsMap: row.objectId
        ? {
            [row.objectlabelname]: {
              id: row.objectId,
              details: {
                id: row.objectId,
                objectlabel: row.objectlabelname,
                objectname: row.objects,
              },
            },
          }
        : {},
      transformationQuery: row.transformationQuery || "",
      flatteningOption: row.flatteningOption ,
      orderId: row.orderId,
      reference_source:row.reference_source,
      reference_target:row.reference_target,
      reference_library:row.reference_library,
      global_external_object:row.global_external_object,
      reference_vault_object:row.reference_vault_object,
      reference_global_object:row.reference_global_object,
      reference_global_source_library:row.reference_global_source_library,
      objectGroupName:row.objectGroupName,
      objectGroupId:this.getObjectGroupName(row.objectGroupName),
      reference_Database_Object_Name:row.reference_Database_Object_Name,
      reference_Database_Object_Fetch_Partial:row.reference_Database_Object_Fetch_Partial,
      rows: [
        {
          objectId: row.objectId,
          objectLabel: row.objectlabelname,
          objects: row.objects,
          attributes: row.attributes,
          reference_source: row.reference_source,
          reference_target: row.reference_target,
          reference_library: row.reference_library,
          reference_global_object: row.reference_global_object,
          reference_global_source_library: row.reference_global_source_library,
          reference_vault_object: row.reference_vault_object,
          global_external_object: row.global_external_object,
          remarks: row.remarks || "",
          reference_Database_Object_Name:row.reference_Database_Object_Name,
          reference_Database_Object_Fetch_Partial:row.reference_Database_Object_Fetch_Partial
        },
      ],
    }
  });
  console.log("stageJson",stageJsons)
  this.finalStageJsons = stageJsons;
  console.log(this.finalStageJsons);
  this.validStageJsons = this.finalStageJsons.filter(stage => 
  stage.rows.every(r => !r.remarks || r.remarks === "")
);

this.invalidStageJsons = this.finalStageJsons.filter(stage => 
  stage.rows.some(r => r.remarks && r.remarks !== "")
);
console.log(this.validStageJsons)
console.log(this.invalidStageJsons)
this.invalidRowdataOfStage = this.invalidStageJsons.map(stage => ({
  datasetname: stage.datasetname,
  description: stage.description,
  columns: stage.columns.map(c => c.alias).join(", "),
  sorting: stage.sorting.map(s => `${s.orderKeyAlias} ${s.orderAllign}`).join(", "),
  columnfilter: stage.columnFiltersExpression || "",
  transformationQuery: stage.transformationQuery,
  // 🔹 collect all row-level remarks
  remarks: stage.rows
    .filter(r => r.remarks) // only those with errors
    .map(r => `${r.objectLabel || r.objects}: ${r.remarks}`)
    .join(" | ")
}));

}
getObjectGroupName(objectGroupName){
  console.log(this.data.objectGroupData);
  const group = this.data.objectGroupData.find(
  item => item.objectGroupName === objectGroupName && item.status?.trim().toLowerCase() === "yes"
);
if (group) {
  return group.objectGroupId;
} else {
  return null;
}
  
}
mapSorting(rowData: any[]): any[] {
  const result: any[] = [];

  rowData.forEach(r => {
    if (!r.sorting || !r.matchedAttributes) return;

    // Split top-level objects (look for objectName:[...])
    const objectBlocks = r.sorting.match(/\w+:\[[^\]]*\]/g);
    if (!objectBlocks) return;

    objectBlocks.forEach(block => {
      const [objectName, attrsPart] = block.split(":");
      if (!objectName || !attrsPart) return;

      const attrsString = attrsPart.replace("[", "").replace("]", "").trim();
      if (!attrsString) return;

      const attrs = attrsString.split(",").map(a => a.trim());

      attrs.forEach(attrDir => {
        const [field, direction] = attrDir.split(";").map(s => s.trim());
        if (!field) return;

        // Lookup matched attribute for label (case-insensitive)
        const attr = (r.matchedAttributes || []).find(
          a => a.name.toLowerCase() === field.toLowerCase()
        );

        result.push({
          orderKey: field,
          orderAllign: (direction || "ASC").toUpperCase(),
          orderObject: objectName,
          orderKeyAlias: attr?.label ? `${attr.label} (${field})` : field
        });
      });
    });
  });

  return result;
}



// private mapColumns(rowData: any[]): any[] {
//   return rowData.flatMap(row => {
//     if (!row.attributes) {
//       console.log("No attributes for this row");
//       return [];
//     }

//     const validFields = row.attributes
//       .split(",")
//       .map(field => field.trim())
//       .filter(field => field.length > 0);

//     return validFields.map(field => {
//       // Try to fetch matching attribute if available
//       const attr = row.matchedAttributes?.find((a: any) => a.name === field);

//       return {
//         name: field,
//         alias: `${row.objectlabelname} ${attr?.label} (${field})`,         // fallback
//         object: row.objects,
//         type: attr?.type || "String",                       // safe access with ?
//         label: `${attr?.label} (${field})`,                   // fallback if no match
//         reporting: attr?.reporting || "Y",
//         objectLabel: row.objectlabelname
//       };
//     });
//   });
// }

private mapColumns(rowData: any[]): any[] {
  return rowData.flatMap(row => {
    if (!row.attributes) {
      console.log("No attributes for this row");
      return [];
    }
console.log(rowData)
    // Parse attributes string into object -> attributes[]
    const parsed = this.parseAttributesforeachobject(row.attributes);

    // Split object names and labels into arrays
    const objectNames = (row.objects || "")
      .split(",")
      .map((o: string) => o.trim());
    const objectLabels = (row.objectlabelname || "")
      .split(",")
      .map((l: string) => l.trim());
    // For each object in parsed result, build column entries
    return Object.entries(parsed).flatMap(([objectName, attrs]) => {
      // find index of this objectName in row.objects
      const idx = objectNames.findIndex(o => o.toLowerCase() === objectName.toLowerCase());
       let objLabel = idx >= 0 && idx < objectLabels.length? objectLabels[idx]: "";
      return attrs.map(field => {
         const attrField = field.field;
        const attr = row.matchedAttributes?.find((a: any) => a.name.toLowerCase().trim() === attrField.toLowerCase().trim());
        console.log("++++++++++++++++++++++++++++")
        console.log(attr)
        const alias = field.alias && field.alias.trim()
          ? field.alias
          : `${objLabel} ${attr?.label || field.field} (${field.field})`;
        return {
          name: field.field,
          // alias: `${objLabel} ${attr?.label || field} (${field})`,
          alias,
          object: objectName,
          type: attr?.type || "String",
          label: `${attr?.label || field.field} (${field.field})`,
          reporting: attr?.reporting || "Y",
          objectLabel: objLabel
        };
      });
    });
  });
}

// private parseAttributesforeachobject(attributeString: string): Record<string, { field: string; alias?: string }[]> {
//   const objectMap: Record<string, { field: string; alias?: string }[]> = {};


//   if (!attributeString || !attributeString.trim()) {
//     return objectMap; // return empty if nothing
//   }

//   // Split at commas followed by some word + :[
//   const groups = attributeString.split("],").map(g => g.trim());

//   groups.forEach(group => {
//     let cleanGroup = group;
//     if (!cleanGroup.endsWith("]")) {
//       cleanGroup = cleanGroup + "]"; // normalize
//     }

//     const [objectPart, attrsPart] = cleanGroup.split(":");
//     if (!objectPart || !attrsPart) return;
//    let attributes: { field: string; alias?: string }[] = [];
//     const objectName = objectPart.trim();
//     const rawAttrs = attrsPart.replace("[", "").replace("]", "").trim();
//     // const attributes = attrsPart
//     //   .replace("[", "")
//     //   .replace("]", "")
//     //   .split(",")
//     //   .map(a => a.trim())
//     //   .filter(a => a.length > 0)
//     //   .map(attr => {
//     //     // check for alias
//     //     const [field, alias] = attr.split("$$AS$$").map(s => s.trim());
//     //     return { field, alias };
//     //   });
//     // rawAttrs === "*" || rawAttrs === '"*"' || rawAttrs === "'*'"
//       if (rawAttrs.includes("*")) {
//       // Expand wildcard from listOfSourceObjects
//       const sourceObj = this.listOfObjectsOfSource.find(
//         obj => obj.objectname.toLowerCase() === objectName.toLowerCase()
//       );
//       if (sourceObj?.objectattributes) {
//         try {
//           const parsedAttrs = JSON.parse(sourceObj.objectattributes || "[]");
//           if(Array.isArray(parsedAttrs)){
//             attributes = parsedAttrs.map((a: any) => ({
//             field: a.name,
//             // alias: a.label // you can drop this if alias should only come from $$AS$$
//           }));
//           } else if(parsedAttrs.datasets && Array.isArray(parsedAttrs.datasets)){
//              attributes = parsedAttrs.datasets.flatMap((item : any)=>item.columns || []).
//                           map((a: any) => ({
//                              field: a.name,
//                               // alias: a.label // you can drop this if alias should only come from $$AS$$
//                              }));
//           }
//            const extraAttrs = rawAttrs
//         .split(",")
//         .map(a => a.trim())
//         .filter(a => a.length > 0 && a.replace(/['"]+/g, "") !== "*")
//         .map(attr => {
//           const [field, alias] = attr.split("$$AS$$").map(s => s.trim());
//           return { field, alias };
//         });

//       attributes = [...attributes, ...extraAttrs];
//         } catch (e) {
//           console.error("Failed to parse objectattributes for", objectName, e);
//         }
//       }
//     } else {
//       // Normal attribute parsing
//       attributes = rawAttrs
//         .split(",")
//         .map(a => a.trim())
//         .filter(a => a.length > 0)
//         .map(attr => {
//           const [field, alias] = attr.split("$$AS$$").map(s => s.trim());
//           return { field, alias };
//         });
//     }
//       console.log(attributes)
//     objectMap[objectName.trim()] = attributes;

//   });
// console.log(objectMap)
//   return objectMap;
// }
private parseAttributesforeachobject(attributeString: string): Record<string, { field: string; alias?: string }[]> {
  const objectMap: Record<string, { field: string; alias?: string }[]> = {};

  if (!attributeString || !attributeString.trim()) {
    return objectMap;
  }

  // Split into groups like "CASE_MASTER_TEST:[...]" and "CASE_MASTER:[...]"
  const groups = attributeString.split("],").map(g => g.trim());

  groups.forEach(group => {
    let cleanGroup = group;
    if (!cleanGroup.endsWith("]")) {
      cleanGroup = cleanGroup + "]"; // normalize
    }

    const [objectPart, attrsPart] = cleanGroup.split(":");
    if (!objectPart || !attrsPart) return;

    let objectName = objectPart.trim();
    const rawAttrs = attrsPart.replace("[", "").replace("]", "").trim();

    let attributes: { field: string; alias?: string }[] = [];

    // Split attributes into list
    const attrList = rawAttrs.length > 0 ? rawAttrs.split(",").map(a => a.trim()).filter(a => a.length > 0) : [];

    // If * present → expand
    if (attrList.includes("*")) {
      const sourceObj = this.listOfObjectsOfSource.find(
        obj => obj.objectname.toLowerCase() === objectName.toLowerCase()
      );

      if (sourceObj?.objectattributes) {
        try {
          const parsedAttrs = JSON.parse(sourceObj.objectattributes || "[]");

          if (Array.isArray(parsedAttrs)) {
            attributes = parsedAttrs.map((a: any) => ({
              field: a.name,
            }));
          } else if (parsedAttrs.datasets && Array.isArray(parsedAttrs.datasets)) {
            attributes = parsedAttrs.datasets.flatMap((ds: any) =>
              (ds.columns || []).map((col: any) => ({
                field: col.name,
              }))
            );
          }
        } catch (e) {
          console.error("Failed to parse objectattributes for", objectName, e);
        }
      }
    }
      //  New check: remap only if objectName is not in source list
    // const existsInSource = this.listOfObjectsOfSource.some(
    //   obj => obj.objectname.toLowerCase() === objectName.toLowerCase()
    // );

    // if (!existsInSource && this.listOfObjectsOfSource.length > 0) {
    //   const defaultObj = this.listOfObjectsOfSource[0];
    //   console.warn(`Object '${objectName}' not found. Using default '${defaultObj.objectname}' instead.` );
    //   objectName = defaultObj.objectname; // remap only if missing
    // }

    // Handle non-* attributes (including aliases)
    const extraAttrs = attrList
      .filter(a => a.replace(/['"]+/g, "") !== "*")
      .map(attr => {
        const [field, alias] = attr.split("$$AS$$").map(s => s.trim());
        return { field, alias };
      });

    // Merge and dedupe
    const seen = new Set<string>();
    const merged = [...attributes, ...extraAttrs].filter(attr => {
      if (seen.has(attr.field.toLowerCase())) return false;
      seen.add(attr.field.toLowerCase());
      return true;
    });

    objectMap[objectName] = merged;
  });

  console.log("Final objectMap:", objectMap);
  return objectMap;
}

private mapColumnFilters(rowData: any[]): any[] {
  const filters: any[] = [];

  // iterate row by row (no premature grouping)
  rowData.forEach(r => {
    if (r.columnfilter && r.columnfilter.trim()) {
      const parsed = this.parseColumnFilter(r.columnfilter.trim());
      if (parsed) filters.push(parsed);
    }
  }); 

  if (filters.length === 0) return [];

  // Combine multiple top-level filters with AND
  // if (filters.length === 1) return [filters[0]];

  return [
    {
      type: "group",
      condition: "AND",
      rules: filters
    }
  ];
}

private parseColumnFilter(expression: string): any {
  expression = expression.trim();

  // If the expression is wrapped in parentheses, keep as nested group
  if (expression.startsWith("(") && expression.endsWith(")") && this.isBalanced(expression.slice(1, -1))) {
    const inner = expression.slice(1, -1).trim();
    return {
      type: "group",
      condition: "AND", // default for nested parentheses
      rules: this.splitTopLevel(inner).map(token => this.parseColumnFilter(token))
    };
  }

  // Split top-level AND/OR (outside parentheses)
  const tokens = this.splitTopLevel(expression);

  if (tokens.length === 1) {
    // It's a single rule, parse it
    return this.parseRule(tokens[0]);
  }

  // Multiple tokens → treat all with top-level AND by default
  return {
    type: "group",
    condition: "AND",
    rules: tokens.map(token => this.parseColumnFilter(token))
  };
}

// Split an expression by top-level AND/OR (outside parentheses)
private splitTopLevel(expr: string): string[] {
  const tokens: string[] = [];
  let depth = 0;
  let current = "";

  for (let i = 0; i < expr.length; i++) {
    const ch = expr[i];

    if (ch === "(") depth++;
    if (ch === ")") depth--;

    // Look for AND/OR at depth 0
    if (depth === 0) {
      if (expr.slice(i, i + 4).toUpperCase() === " AND") {
        tokens.push(current.trim());
        current = "";
        i += 3; // skip " AND"
        continue;
      } else if (expr.slice(i, i + 3).toUpperCase() === " OR") {
        tokens.push(current.trim());
        current = "";
        i += 2; // skip " OR"
        continue;
      }
    }
    current += ch;
  }

  if (current.trim()) tokens.push(current.trim());
  return tokens;
}

private parseRule(expression: string): any {
  const regex = /([\w.]+?)(?:__v)?\.'([\w.]+)' *([=><!]+) *'([^']+)'/;
  const match = expression.match(regex);
  if (!match) return { type: "unknown", raw: expression };

  return {
    type: "rule",
    object: match[1] + (expression.includes("__v") ? "__v" : ""),
    field: match[2],
    operator: match[3],
    value: match[4]
  };
}

private isBalanced(expr: string): boolean {
  let depth = 0;
  for (const ch of expr) {
    if (ch === "(") depth++;
    if (ch === ")") {
      depth--;
      if (depth < 0) return false;
    }
  }
  return depth === 0;
}




// private mapColumnFilters(rowData: any[]): any[] {
//   const filters: any[] = [];

//   rowData.forEach(r => {
//     if (r.columnfilter) {
//       const expression = r.columnfilter; // e.g. transmission_message__v.'id' > '1'
//       const parsed = this.parseFilterExpression(expression);
//       if (parsed) filters.push(parsed);
//     }
//   });

//   return [
//     {
//       type: "group",
//       condition: "AND",
//       rules: filters
//     }
//   ];
// }
private parseFilterExpression(expression: string): any {
  // Example: transmission_message__v.'id' > '1'
  const regex = /(\w+)__v\.'(\w+)' *([=><!]+) *'([^']+)'/;
  const match = expression.match(regex);

  if (!match) return null;

  return {
    type: "rule",
    object: match[1] + "__v",
    field: match[2],
    operator: match[3],
    value: match[4]
  };
}
private buildColumnFiltersExpression(rowData: any[]): string {
  // Use proper typing: Record<string, Set<string>>
  const stageGroups: Record<string, Set<string>> = rowData.reduce((acc, row) => {
    const key = row["Stage Object Name"] || row.objects;
    if (!acc[key]) acc[key] = new Set<string>();
    if (row.columnfilter) acc[key].add(row.columnfilter.trim());
    return acc;
  }, {} as Record<string, Set<string>>);

  const expressions: string[] = [];
  for (const filtersSet of Object.values(stageGroups)) {
    const typedSet = filtersSet as Set<string>; // type assertion
    if (typedSet.size === 0) continue;

    const arr = Array.from(typedSet); // convert Set back to array
    expressions.push(arr.length > 1 ? `(${arr.join(") AND (")})` : arr[0]);
  }

  return expressions.join(" AND ");
}


groupEachSatgeAsJson<T>(array: T[],keyGetter: (item: T) => string){
  // Result will be stored in grouped object
 const grouped: Record<string, T[]> = {};

  // Loop through every row/item in array
  for (const item of array) {
    // Get the key (example: student.class)
    const key = keyGetter(item);

    // If no group created yet for this key, create an empty array
    if (!grouped[key]) {
      grouped[key] = [];
    }

    // Add the item into that group
    grouped[key].push(item);
  }
  // Return final grouped object
  return grouped;
}
validateRowData(rowData: any[], objectsList: any[]): any[] {
  // Step 1: Preprocess objects list into Map
   const objectNameMap = new Map<string, any>(); // objectname -> obj
  const objectLabelMap = new Map<string, any>(); // objectlabel -> obj
  const objectMap = new Map<
    string,
    { obj: any; attrMap: Map<string, any> }
  >();

  for (const obj of objectsList) {
    let attrs: any[] = [];
    try {
      const parsedDadata = JSON.parse(obj.objectattributes || "[]"); // [{name:"a", type:"string"}, ...]
      if(Array.isArray(parsedDadata)){
        attrs = parsedDadata;
      }else if(parsedDadata.datasets && Array.isArray(parsedDadata.datasets)){

        attrs = parsedDadata.datasets.flatMap((item : any) => item.columns || []);

      }
      console.log("Attribute",attrs)
    } catch (e) {
      console.error("Invalid attributes JSON for object:", obj.objectname);
    }

    // Create a map of attributeName -> attributeObject
    const attrMap = new Map(attrs.map((a) => [a.name.toLowerCase().trim(), a]));
    // objectMap.set(obj.objectname.trim(), { obj, attrMap });
     objectNameMap.set(obj.objectname.trim().toLowerCase(), obj);
    objectLabelMap.set(obj.objectlabel.trim().toLowerCase(), obj);
    objectMap.set(
      `${obj.objectname.trim().toLowerCase()}|${obj.objectlabel.trim().toLowerCase()}`,
      { obj, attrMap }
    );
  }
  console.log("ObjectMap",objectMap)
  // Step 2: Validate rowData
  return rowData.map((row) => {
    const remarks: string[] = [];
    let matchedAttributes: any[] = [];
    let objectIds: any[] = [];
      const rowObjectNames = (row.objects || "")
      .split(",")
      .map((o: string) => o.trim().toLowerCase())
      .filter(Boolean);

    const rowObjectLabels = (row.objectlabelname || "")
      .split(",")
      .map((l: string) => l.trim().toLowerCase())
      .filter(Boolean);
    console.log("Row Input =>", {
  rawName: row.objects,
  normalizedName: rowObjectNames,
  rawLabel: row.objectlabel,
  normalizedLabel: rowObjectLabels
});

if (rowObjectNames.length !== rowObjectLabels.length) {
      remarks.push(
        `Mismatch: found ${rowObjectNames.length} object(s) but ${rowObjectLabels.length} label(s)`
      );
    }
  //   const parsedAttrsByObject = this.parseAttributesforeachobject(row.attributes);
  //   for (const attrObjectName of Object.keys(parsedAttrsByObject)) {
  //     if (!rowObjectNames.includes(attrObjectName.toLowerCase().trim())) {
  //       remarks.push(`Object '${attrObjectName}' found in attributes but not in Objects column`);
  //    }
  // }
  // Validate each (object, label) pair
    // rowObjectNames.forEach((name, i) => {
    //   const label = rowObjectLabels[i] || "";
    //   const entry = objectMap.get(`${name}|${label}`);

    //   if (!entry) {
    //     const nameExists = objectNameMap.has(name);
    //     const labelExists = objectLabelMap.has(label);
    //     if (!nameExists) {
    //       remarks.push(`Object name '${name}' not found`);
    //     } else if (!labelExists) {
    //       remarks.push(`Object label '${label}' not found for '${name}'`);
    //     } else {
    //       remarks.push(`Mismatch: object '${name}' does not belong to label '${label}'`);
    //     }
    //   } else {
    //     objectIds.push(entry.obj.id);

    //   }
    // });
    // console.log("Matched Attributes",matchedAttributes)
    //   if (row.sorting && row.sorting.trim()) {
    //   const sortingBlocks = row.sorting.match(/\w+:\[[^\]]*\]/g);
    //   if (sortingBlocks) {
    //     sortingBlocks.forEach(block => {
    //       const [objNameRaw, attrsPart] = block.split(":");
    //       const objName = objNameRaw?.trim();
    //       const attrsString = attrsPart?.replace("[", "").replace("]", "").trim();
    //       if (!objName || !attrsString) return;

    //       // if (!rowObjectNames.includes(objName)) {
    //       //   remarks.push(`Sorting object '${objName}' not found in Objects column`);
    //       // } else {
    //       //   const attrs = attrsString.split(",").map(a => a.trim());
    //       //   attrs.forEach(attrDir => {
    //       //     const [field] = attrDir.split(";").map(s => s.trim().toLowerCase());
    //       //     if (!parsedAttrsByObject[objName] || !parsedAttrsByObject[objName].includes(field)) {
    //       //       remarks.push(`Sorting attribute '${field}' not found in Attributes column of '${objName}'`);
    //       //     }
    //       //   });
    //       // }
    //         const keyMatch = this.findKeyIgnoreCase(parsedAttrsByObject, objName);

    //   if (!keyMatch) {
    //     remarks.push(`Sorting object '${objName}' not found in Attributes column`);
    //   } else {
    //     const attrsForObj = parsedAttrsByObject[keyMatch];
    //     const attrs = attrsString.split(",").map(a => a.trim());

    //     attrs.forEach(attrDir => {
    //       const [field] = attrDir.split(";").map(s => s.trim());

    //       //  Case-insensitive check inside attributes
    //       const match = attrsForObj.find(a => a.toLowerCase() === field.toLowerCase());
    //       if (!match) {
    //         remarks.push(`Sorting attribute '${field}' not found in Attributes column of '${objName}'`);
    //       }
    //     });
    //   }
    //     });
    //   }
    // }

    return {
      ...row,
      objectIds,
      matchedAttributes, // all valid attributes with details
      remarks: remarks.length > 0 ? remarks.join("; "):""
    };
  });
}

handleBackendResponse(response: any[]): void {
  console.log("Backend Response:", response);

  // Extract backend rows
  // const backendRows = response.flatMap(stage => stage.rows || []);

  // Merge backend rows + locally stored invalid rows
  this.rowData = [
    // ...backendRows,
    ...(this.invalidStageRows || [])
  ];

  // Show everything in grid
  if (this.gridAPI) {
    this.gridAPI.setGridOption('rowData', this.rowData);
  }

  console.log("Final rowData shown in grid:", this.rowData);
}
simulateFlow(rowData: any[]) {
  // Step 1: Build JSON
  const stageJsons = this.mapStageJson(rowData);

  // Step 2: Pretend this is backend response
  this.handleBackendResponse(stageJsons);
}

setStageResponseintogrid(){
 this.columnDefs = [
   {
      headerName: 'Object Group Name',
      headerTooltip: 'Object Group Name',
      tooltipValueGetter: (params) => 'Object Group Name : ' + params.value,
      field: 'objectGroupName',
      filter: 'agTextColumnFilter',
      width: 230
    },
  { headerName: 'Stage Object Label',headerTooltip:'Stage Object Label', tooltipValueGetter: (params) => 'Stage Object Label : ' + params.value, field: 'datasetname', filter: 'agTextColumnFilter', width: 150 },
  { headerName: 'Stage Object Name',headerTooltip:'Stage Object Name',tooltipValueGetter: (params) => 'Stage Object Name : ' + params.value, field: 'description', filter: 'agTextColumnFilter', width: 200 },
  { headerName: 'Columns',headerTooltip:'Columns',tooltipValueGetter: (params) => 'Columns : ' + params.value, field: 'columns', filter: 'agTextColumnFilter', width: 300 }, 
  { headerName: 'Sorting',headerTooltip:'Sorting',tooltipValueGetter: (params) => 'Sorting : ' + params.value, field: 'sorting', filter: 'agTextColumnFilter', width: 250 },
  { headerName: 'Column Filter',headerTooltip:'Column Filter',tooltipValueGetter: (params) => 'Column Filter : ' + params.value, field: 'columnfilter', filter: 'agTextColumnFilter', width: 250 },
  { headerName: 'Transformation Query',headerTooltip:'Transformation Query',tooltipValueGetter: (params) => 'Transformation Query : ' + params.value, field: 'transformationQuery', width: 400 },
  { headerName: 'Remarks',headerTooltip:'Remarks',tooltipValueGetter: (params) => 'Remarks : ' + params.value, field: 'remarks', width: 300 }
];

}
   validateStageField(fieldName: string, value: string, rowIndex: number): string | null {
  // special char check
  if (/[<>()'"/\\*;:=\{\}`%+\^!]/.test(value)) {
    return `${fieldName} has invalid characters at row ${rowIndex + 1}`;
  }

  // whitespace-only check
  if (value.trim().length === 0) {
    return `${fieldName} cannot be empty or whitespace at row ${rowIndex + 1}`;
  }

  // length check
  if (value.length > 100) {
    return `${fieldName} must not exceed 100 characters at row ${rowIndex + 1}`;
  }

  return null; 
}
validateObjectGroupName(row: any, rowIndex: number){
  console.log(row);
  console.log(rowIndex);
  console.log(this.data.objectGroupData);
  const group = this.data.objectGroupData.find(
  item => item.objectGroupName === row.objectGroupName
);

if (group) {
  console.log('Found:', group);
  this.rowData[rowIndex]={
    ...this.rowData[rowIndex],
     objectGroupId:group.objectGroupId
  }
} else {
  console.log('Not Found');
          return `Row ${rowIndex + 1}: Object Group Name "${row.objectGroupName}" not found in object group list.`;
}

  
}
validateReferenceColumns(row: any, rowIndex: number): string | null {
  const refSourceObject = row['reference_source'];
  if (refSourceObject && typeof refSourceObject === 'string') {
    const refSourceObjectName = refSourceObject.split(',').map(obj => obj.trim().toLowerCase());
    for (const name of refSourceObjectName) {
      if (!this.sourceObjectNameSet.has(name)) {
        return `Row ${rowIndex + 1}: Reference Source Object "${name}" not found in source objects list.`;
      }
    }
  }

  const refGlobalObj = row['reference_global_object'];
  if (refGlobalObj && typeof refGlobalObj === 'string') {
    const refGlobalObjectName = refGlobalObj.split(',').map(obj => obj.trim().toLowerCase());
    for (const name of refGlobalObjectName) {
      const existedreferencetarget = this.referenceGlobalObjectsList
        .some(obj => obj.objectname && obj.objectname.toLowerCase().trim() === name);
      if (!existedreferencetarget) {
        return `Row ${rowIndex + 1}: Reference Global Object "${name}" not found in global objects list.`;
      }
    }
  }

  const refTargetObj = row['reference_target'];
  if (refTargetObj && typeof refTargetObj === 'string') {
    const refTargetObjectName = refTargetObj.split(',').map(obj => obj.trim().toLowerCase());
    for (const name of refTargetObjectName) {
      const existedreferenceglobal = this.data.stageObjectslist
        .some(obj => obj.description && obj.description.toLowerCase().trim() === name);
      if (!existedreferenceglobal) {
        return `Row ${rowIndex + 1}: Reference Transform Object "${name}" not found in transform objects list.`;
      }
    }
  }

  const refLibraryObj = row['reference_vault_object'];
  if (refLibraryObj && typeof refLibraryObj === 'string') {
    const refLibraryObjectName = refLibraryObj.split(',').map(obj => obj.trim().toLowerCase());
    console.log(refLibraryObj)
    for (const name of refLibraryObjectName) {
      const existedRefLibraryobject = this.referenceLibraryObjectsList
        .some(obj => obj.objectname && obj.objectname.trim().toLowerCase() === name);
      if (!existedRefLibraryobject) {
        return `Row ${rowIndex + 1}: Reference Library Object "${name}" not found in target objects list.`;
      }
    }
  }

  const refGlobalSourceObj = row['reference_global_source_library'];
  if (refGlobalSourceObj && typeof refGlobalSourceObj === 'string') {
    const refGlobalSourceObjectName = refGlobalSourceObj.split(',').map(obj => obj.trim().toLowerCase());
    for (const name of refGlobalSourceObjectName) {
       const existedRefGlobalSourceObj = this.referenceSourceGlobalObjectsList
        .some(obj => obj.objectname && obj.objectname.trim().toLowerCase() === name);
      if (!existedRefGlobalSourceObj) {
        return `Row ${rowIndex + 1}: Reference Global Source Object "${name}" not found in source objects list.`;
      }
    }
  }

  const globalExternalObj = row['global_external_object'];
  if (globalExternalObj && typeof globalExternalObj === 'string') {
    const globalExternalObjectName = globalExternalObj.split(',').map(obj => obj.trim().toLowerCase());
    for (const name of globalExternalObjectName) {
      const existedreferencetarget = this.referenceExternalObjectsList
        .some(obj => obj.objectname && obj.objectname.toLowerCase().trim() === name);
      if (!existedreferencetarget) {
        return `Row ${rowIndex + 1}: Global External Object "${name}" not found in source objects list.`;
      }
    }
  }

  const referenceValueMapping = row['reference_library'];
  if (referenceValueMapping && typeof referenceValueMapping === 'string') {
    const refValueMapping = referenceValueMapping.split(',').map(obj => obj.trim().toLowerCase());
    for (const name of refValueMapping) {
      const existedreferencetarget = this.codeListData
        .some(obj => obj.mappingTypeName && obj.mappingTypeName.toLowerCase().trim() === name);
      if (!existedreferencetarget) {
        return `Row ${rowIndex + 1}: Reference Value Mapping "${name}" not found in Library List.`;
      }
    }
  }

  
          const reference_Database_Object_Name = row['reference_Database_Object_Name']
          if(reference_Database_Object_Name && typeof reference_Database_Object_Name === 'string'){
             const ref_Database_Object_Name = reference_Database_Object_Name.split(',').map(obj => obj.trim().toLowerCase());
             for(const name of ref_Database_Object_Name){
                const existed_ref_Database_Object_Name = this.referenceTargetObjectsList.some(obj =>obj.objectname && obj.objectname.toLowerCase().trim() === name);
              if(!existed_ref_Database_Object_Name){
                return `Row ${rowIndex + 1}: Reference DB Object Name "${name}" not found in Target Object List`
                
             }
             }
          }

          const reference_Database_Object_Fetch_Partial = row['reference_Database_Object_Fetch_Partial']
          if(reference_Database_Object_Fetch_Partial && typeof reference_Database_Object_Fetch_Partial === 'string'){
             const ref_Database_Object_Fetch_Partial = reference_Database_Object_Fetch_Partial.split(',').map(obj => obj.trim().toLowerCase());
             for(const name of ref_Database_Object_Fetch_Partial){
                const existed_ref_Database_Object_Fetch_Partial = this.referenceTargetObjectsList.some(obj =>obj.objectname && obj.objectname.toLowerCase().trim() === name);
              if(!existed_ref_Database_Object_Fetch_Partial){
              
                return `Row ${rowIndex + 1}: Reference DB Object Fetch Partials "${name}" not found in Target Object List.`
             }
             }
          }
  return null; 
}

private findKeyIgnoreCase(obj: Record<string, any>, key: string): string | undefined {
  return Object.keys(obj).find(k => k.toLowerCase() === key.toLowerCase());
}


}


 
 
